var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _circle, _circle2, _path14, _path15, _circle3, _path16, _circle4, _circle5, _path17, _path18, _path19, _path20, _circle6, _circle7, _path21, _path22, _circle8, _path23, _path24, _circle9, _path25, _circle0, _circle1, _path26, _path27, _circle10, _circle11, _circle12, _circle13, _path28, _path29, _circle14, _circle15, _circle16, _path30, _circle17, _circle18, _path31, _path32, _circle19, _path33, _path34, _circle20, _path35, _circle21, _circle22, _path36, _path37, _circle23, _circle24, _circle25, _circle26, _path38, _circle27, _path39, _path40, _circle28, _circle29, _path41, _circle30, _path42, _path43, _circle31, _path44, _path45, _circle32, _path46, _circle33, _circle34, _path47, _path48, _circle35, _circle36, _circle37, _circle38, _path49, _path50, _path51, _circle39, _circle40, _path52, _circle41, _path53, _path54, _circle42, _path55, _path56, _circle43, _path57, _circle44, _circle45, _path58, _path59, _circle46, _circle47, _circle48, _circle49, _path60, _circle50, _circle51, _path61, _path62, _path63, _path64, _circle52, _path65, _circle53, _circle54, _path66, _path67, _circle55, _circle56, _circle57, _circle58, _path68, _circle59, _circle60, _path69, _path70, _circle61, _path71, _circle62, _path72, _circle63, _circle64, _path73, _path74, _circle65, _circle66, _circle67, _path75, _circle68, _circle69, _path76, _path77, _circle70, _path78, _circle71, _path79, _circle72, _path80, _circle73, _circle74, _path81, _path82, _circle75, _circle76, _circle77, _circle78, _circle79, _path83, _path84, _path85, _circle80, _circle81, _path86, _circle82, _path87, _circle83, _circle84, _circle85, _path88, _circle86, _circle87, _path89, _path90, _circle88, _circle89, _circle90, _path91, _circle91, _circle92, _path92, _circle93, _circle94, _circle95, _path93, _circle96, _circle97, _path94, _circle98, _circle99, _path95, _circle100, _circle101, _path96, _path97, _circle102, _path98, _circle103, _circle104, _path99, _path100, _path101, _path102, _circle105, _circle106, _path103, _circle107, _circle108, _path104, _circle109, _circle110, _path105, _circle111, _circle112, _path106, _circle113, _circle114, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _circle115, _circle116, _path142, _circle117, _circle118, _path143, _circle119, _circle120, _path144, _circle121, _path145, _circle122, _path146, _path147, _path148, _circle123, _path149, _path150, _circle124, _path151, _circle125, _circle126, _path152, _path153, _circle127, _circle128, _path154, _circle129, _circle130, _path155, _circle131, _circle132, _path156, _circle133, _circle134, _circle135, _path157, _circle136, _path158, _circle137, _circle138, _path159, _circle139, _circle140, _path160, _circle141, _path161, _circle142, _path162, _circle143, _circle144, _path163, _path164, _circle145, _path165, _circle146, _circle147, _path166, _circle148, _circle149, _path167, _circle150, _circle151, _path168, _circle152, _path169, _circle153, _circle154, _circle155, _path170, _circle156, _circle157, _circle158, _circle159, _circle160, _path171, _circle161, _path172, _circle162, _path173, _path174, _circle163, _path175, _circle164, _circle165, _path176, _circle166, _circle167, _path177, _circle168, _circle169, _path178, _circle170, _circle171, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _circle172, _path245, _circle173, _circle174, _path246, _circle175, _circle176, _path247, _circle177, _path248, _circle178, _circle179, _path249, _path250, _circle180, _path251, _path252, _circle181, _circle182, _path253, _circle183, _circle184, _path254, _path255, _circle185, _path256, _circle186, _circle187, _path257, _circle188, _circle189, _path258, _circle190, _circle191, _path259, _circle192, _circle193, _path260, _circle194, _path261, _circle195, _circle196, _path262, _circle197, _circle198, _path263, _circle199, _path264, _circle200, _circle201, _path265, _path266, _circle202, _path267, _path268, _circle203, _path269, _circle204, _path270, _circle205, _path271, _path272, _circle206, _circle207, _path273, _circle208, _circle209, _path274, _path275, _circle210, _path276, _circle211, _circle212, _path277, _circle213, _circle214, _path278, _circle215, _circle216, _path279, _circle217, _circle218, _path280, _circle219, _path281, _circle220, _circle221, _path282, _circle222, _circle223, _path283, _path284, _circle224, _path285, _circle225, _circle226, _path286, _path287, _path288, _circle227, _circle228, _path289, _circle229, _path290, _path291, _circle230, _circle231, _path292, _circle232, _circle233, _path293, _path294, _circle234, _path295, _circle235, _circle236, _path296, _circle237, _circle238, _path297, _circle239, _circle240, _path298, _circle241, _circle242, _path299, _path300, _path301, _circle243, _path302, _circle244, _circle245, _path303, _circle246, _circle247, _path304, _path305, _circle248, _path306, _circle249, _circle250, _path307, _circle251, _path308, _path309, _circle252, _path310, _circle253, _circle254, _path311, _circle255, _path312, _path313, _circle256, _circle257, _path314, _circle258, _circle259, _path315, _path316, _circle260, _path317, _circle261, _circle262, _path318, _circle263, _circle264, _path319, _circle265, _circle266, _path320, _circle267, _circle268, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _circle269, _path369, _circle270, _circle271, _path370, _circle272, _circle273, _path371, _path372, _circle274, _path373, _circle275, _path374, _path375, _circle276, _circle277, _path376, _circle278, _circle279, _circle280, _path377, _circle281, _circle282, _path378, _circle283, _circle284, _path379, _path380, _circle285, _path381, _circle286, _circle287, _path382, _circle288, _circle289, _path383, _circle290, _circle291, _path384, _circle292, _circle293, _path385, _path386, _path387, _circle294, _path388, _circle295, _circle296, _path389, _circle297, _circle298, _path390, _path391, _circle299, _path392, _circle300, _path393, _circle301, _circle302, _path394, _circle303, _path395, _circle304, _circle305, _path396, _circle306, _circle307, _path397, _path398, _circle308, _path399, _circle309, _circle310, _path400, _circle311, _circle312, _path401, _circle313, _circle314, _path402, _circle315, _circle316, _path403, _path404, _circle317, _path405, _circle318, _path406, _circle319, _circle320, _path407, _circle321, _circle322, _path408, _path409, _circle323, _path410, _circle324, _circle325, _circle326, _path411, _circle327, _circle328, _path412, _path413, _circle329, _path414, _circle330, _circle331, _path415, _circle332, _circle333, _path416, _circle334, _circle335, _path417, _circle336, _circle337, _path418, _path419, _circle338, _path420, _circle339, _path421, _circle340, _circle341, _path422, _circle342, _circle343, _path423, _path424, _circle344, _circle345, _circle346, _circle347, _path425, _path426, _circle348, _circle349, _path427, _path428, _circle350, _path429, _circle351, _circle352, _path430, _circle353, _circle354, _path431, _circle355, _circle356, _path432, _circle357, _circle358, _path433, _path434, _circle359, _path435, _circle360, _path436, _circle361, _circle362, _path437, _circle363, _circle364, _path438, _path439, _circle365, _circle366, _path440, _circle367, _circle368, _path441, _path442, _path443, _circle369, _path444, _circle370, _circle371, _path445, _circle372, _circle373, _path446, _circle374, _circle375, _path447, _circle376, _circle377, _path448, _path449, _circle378, _path450, _circle379, _path451, _circle380, _circle381, _path452, _circle382, _circle383, _path453, _path454, _path455, _circle384, _circle385, _path456, _circle386, _circle387, _path457, _circle388, _circle389, _path458, _path459, _circle390, _path460, _circle391, _circle392, _path461, _circle393, _circle394, _path462, _circle395, _circle396, _path463, _circle397, _circle398, _path464, _path465, _circle399, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _circle400, _path508, _circle401, _path509, _path510, _path511, _path512, _circle402, _circle403, _path513, _circle404, _circle405, _path514, _circle406, _path515, _path516, _circle407, _circle408, _path517, _circle409, _path518, _circle410, _path519, _circle411, _circle412, _circle413, _path520, _circle414, _circle415, _path521, _circle416, _circle417, _path522, _path523, _circle418, _path524, _circle419, _path525, _circle420, _path526, _circle421, _circle422, _path527, _path528, _circle423, _circle424, _path529, _circle425, _circle426, _path530, _circle427, _path531, _path532, _circle428, _circle429, _path533, _circle430, _circle431, _path534, _circle432, _path535, _circle433, _circle434, _path536, _circle435, _circle436, _path537, _circle437, _circle438, _path538, _path539, _circle439, _path540, _circle440, _path541, _path542, _path543, _circle441, _circle442, _path544, _path545, _circle443, _circle444, _path546, _circle445, _circle446, _path547, _circle447, _path548, _path549, _circle448, _circle449, _path550, _circle450, _circle451, _circle452, _path551, _circle453, _circle454, _path552, _circle455, _circle456, _path553, _circle457, _circle458, _path554, _path555, _circle459, _path556, _circle460, _circle461, _circle462, _path557, _circle463, _path558, _path559, _circle464, _circle465, _path560, _circle466, _circle467, _path561, _circle468, _path562, _path563, _circle469, _circle470, _path564, _circle471, _circle472, _circle473, _path565, _circle474, _circle475, _path566, _circle476, _path567, _circle477, _circle478, _path568, _path569, _path570, _circle479, _circle480, _path571, _circle481, _circle482, _circle483, _path572, _circle484, _path573, _path574, _circle485, _circle486, _path575, _circle487, _circle488, _path576, _circle489, _path577, _path578, _circle490, _circle491, _path579, _circle492, _circle493, _path580, _circle494, _path581, _circle495, _circle496, _path582, _path583, _circle497, _circle498, _path584, _path585, _circle499, _circle500, _path586, _path587, _path588, _circle501, _path589, _path590, _circle502, _circle503, _path591, _circle504, _circle505, _path592, _circle506, _path593, _path594, _circle507, _circle508, _path595, _circle509, _circle510, _path596, _path597, _circle511, _circle512, _circle513, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _circle514, _path623, _path624, _circle515, _path625, _circle516, _circle517, _path626, _path627, _circle518, _path628, _path629, _circle519, _circle520, _path630, _circle521, _circle522, _path631, _circle523, _path632, _path633, _circle524, _circle525, _path634, _circle526, _circle527, _path635, _path636, _circle528, _path637, _circle529, _circle530, _circle531, _path638, _circle532, _path639, _circle533, _circle534, _path640, _path641, _circle535, _path642, _path643, _circle536, _circle537, _path644, _circle538, _circle539, _path645, _circle540, _path646, _path647, _circle541, _circle542, _path648, _circle543, _circle544, _path649, _path650, _circle545, _path651, _circle546, _circle547, _circle548, _path652, _circle549, _circle550, _path653, _path654, _circle551, _path655, _path656, _circle552, _circle553, _circle554, _path657, _circle555, _path658, _path659, _circle556, _circle557, _path660, _circle558, _circle559, _path661, _path662, _circle560, _path663, _circle561, _path664, _circle562, _circle563, _path665, _path666, _circle564, _path667, _path668, _path669, _circle565, _path670, _path671, _circle566, _circle567, _path672, _circle568, _circle569, _path673, _path674, _circle570, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _circle571, _path700, _circle572, _circle573, _path701, _path702, _circle574, _path703, _path704, _circle575, _path705, _circle576, _circle577, _path706, _path707, _circle578, _path708, _path709, _circle579, _circle580, _path710, _circle581, _circle582, _path711, _path712, _path713, _circle583, _path714, _circle584, _circle585, _path715, _circle586, _path716, _path717, _circle587, _path718, _path719, _circle588, _circle589, _path720, _circle590, _path721, _circle591, _path722, _circle592, _path723, _path724, _path725, _path726, _circle593, _circle594, _circle595, _path727, _path728, _path729, _circle596, _path730, _path731, _path732, _path733, _circle597, _path734, _path735, _circle598, _circle599, _path736, _path737, _circle600, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _circle601, _path751, _path752, _path753, _path754, _rect, _rect2, _path755, _path756, _path757, _path758, _path759, _circle602, _path760, _rect3, _path761, _path762, _path763, _path764, _path765, _path766;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignInPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ee521cf8-276d-4d1e-900d-5b4e704817f9",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 743.31832,
    height: 819.52927,
    viewBox: "0 0 743.31832 819.52927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M770.85285,855.42322c-6.43422-5.43687-10.34247-14.02552-9.31754-22.38664s7.37308-16.04756,15.60755-17.82308,17.62118,3.13941,20.12226,11.18325c1.37646-15.50821,2.96258-31.6662,11.20774-44.87289,7.46579-11.95834,20.39667-20.515,34.41082-22.04577s28.76926,4.2508,37.50938,15.312,10.8801,27.14188,4.75875,39.841c-4.50939,9.355-12.81726,16.31717-21.52184,21.98123a138.90067,138.90067,0,0,1-94.99923,20.78271",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5347,764.04938a227.26176,227.26176,0,0,0-31.6712,31.44942,227.92451,227.92451,0,0,0-35.672,59.61158c-.64234,1.57405,1.91364,2.25922,2.54883.70268a226.64209,226.64209,0,0,1,66.66345-89.89462c1.3196-1.07454-.56035-2.93475-1.86907-1.86906Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M402.90576,853.78551c9.5355-8.05743,15.32752-20.78579,13.80857-33.177s-10.92689-23.78243-23.13034-26.41375-26.11455,4.65259-29.82113,16.57355c-2.03992-22.98313-4.39055-46.92923-16.60985-66.50151-11.06427-17.72222-30.22781-30.40317-50.99675-32.67177s-42.636,6.29968-55.58879,22.69236-16.12428,40.22419-7.05245,59.04433c6.68289,13.86414,18.99514,24.182,31.89531,32.57612a205.85042,205.85042,0,0,0,140.78859,30.79993",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#f2f2f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M261.10552,718.36972a336.80174,336.80174,0,0,1,46.93663,46.60795,341.61456,341.61456,0,0,1,37.01514,54.782A340.21365,340.21365,0,0,1,360.908,853.32188c.95194,2.33273-2.836,3.34816-3.77737,1.04137a334.31111,334.31111,0,0,0-30.54713-57.79643,336.41428,336.41428,0,0,0-40.96855-50.61069,335.6104,335.6104,0,0,0-27.27936-24.81647c-1.95565-1.59247.83042-4.34928,2.76995-2.76994Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M401.57048,537.33449a.99651.99651,0,0,1-.701-.28662,290.16782,290.16782,0,1,1,428.692-24.3252,1.00013,1.00013,0,0,1-1.55371-1.25976A288.6388,288.6388,0,0,0,892.164,330.23537c0-158.80371-129.19629-288-288-288s-288,129.19629-288,288A285.89387,285.89387,0,0,0,402.27153,535.6216a.99982.99982,0,0,1-.70105,1.71289Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M604.164,620.23537a292.9852,292.9852,0,0,1-48.33936-4.01075,1.00012,1.00012,0,1,1,.33105-1.97265,290.95451,290.95451,0,0,0,48.00831,3.9834,288.01307,288.01307,0,0,0,86.20239-13.12207.99984.99984,0,1,1,.5979,1.9082A290.00124,290.00124,0,0,1,604.164,620.23537Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M456.04,111.533a2.15763,2.15763,0,1,0-2.15771-2.1576A2.15742,2.15742,0,0,0,456.04,111.533Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M507.68693,111.533a2.15763,2.15763,0,1,0-2.15771-2.1576A2.15784,2.15784,0,0,0,507.68693,111.533Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M516.287,107.21779a2.15763,2.15763,0,1,0,2.15772,2.15765A2.15784,2.15784,0,0,0,516.287,107.21779Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M524.90227,107.21779a2.15763,2.15763,0,1,0,2.15771,2.15765A2.15743,2.15743,0,0,0,524.90227,107.21779Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M533.50285,107.21779a2.15763,2.15763,0,1,0,2.15723,2.15765A2.15753,2.15753,0,0,0,533.50285,107.21779Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M542.11809,107.21779a2.15763,2.15763,0,1,0,2.15771,2.15765A2.15785,2.15785,0,0,0,542.11809,107.21779Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M550.71818,107.21779a2.15763,2.15763,0,1,0,2.15772,2.15765A2.15784,2.15784,0,0,0,550.71818,107.21779Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M559.31877,107.21779a2.15763,2.15763,0,1,0,2.15772,2.15765A2.15753,2.15753,0,0,0,559.31877,107.21779Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M567.934,107.21779a2.15763,2.15763,0,1,0,2.15771,2.15765A2.15753,2.15753,0,0,0,567.934,107.21779Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 210.49844,
    cy: 77.75543,
    r: 2.15765,
    fill: "#ccc"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.31435,
    cy: 77.75543,
    r: 2.15765,
    fill: "#ccc"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M473.25529,120.14839a2.15759,2.15759,0,1,0-2.15722-2.15759A2.15752,2.15752,0,0,0,473.25529,120.14839Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M481.871,120.14839a2.15759,2.15759,0,1,0-2.15772-2.15759A2.15741,2.15741,0,0,0,481.871,120.14839Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.13027,
    cy: 77.75543,
    r: 2.15765,
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M499.07121,120.14839a2.15759,2.15759,0,1,0-2.15722-2.15759A2.15752,2.15752,0,0,0,499.07121,120.14839Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.34609,
    cy: 77.75543,
    r: 2.15765,
    fill: "#ccc"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.94619,
    cy: 77.75543,
    r: 2.15765,
    fill: "#ccc"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M524.90227,115.83321A2.15759,2.15759,0,1,0,527.06,117.9908,2.15742,2.15742,0,0,0,524.90227,115.83321Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M533.50285,115.83321a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,533.50285,115.83321Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M576.5341,115.83321a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,576.5341,115.83321Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M585.14983,115.83321a2.15759,2.15759,0,1,0,2.15722,2.15759A2.15752,2.15752,0,0,0,585.14983,115.83321Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.40908,
    cy: 77.75543,
    r: 2.15765,
    fill: "#ccc"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.8832,
    cy: 86.35571,
    r: 2.15765,
    fill: "#ccc"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,128.74867a2.15759,2.15759,0,1,0-2.15723-2.15759A2.15752,2.15752,0,0,0,447.43938,128.74867Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M456.04,128.74867a2.15759,2.15759,0,1,0-2.15771-2.15759A2.15742,2.15742,0,0,0,456.04,128.74867Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.31435,
    cy: 86.35571,
    r: 2.15765,
    fill: "#ccc"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M473.25529,128.74867a2.15759,2.15759,0,1,0-2.15722-2.15759A2.15752,2.15752,0,0,0,473.25529,128.74867Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M481.871,128.74867a2.15759,2.15759,0,1,0-2.15772-2.15759A2.15741,2.15741,0,0,0,481.871,128.74867Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.13027,
    cy: 86.35571,
    r: 2.15765,
    fill: "#ccc"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M499.07121,128.74867a2.15759,2.15759,0,1,0-2.15722-2.15759A2.15752,2.15752,0,0,0,499.07121,128.74867Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.34609,
    cy: 86.35571,
    r: 2.15765,
    fill: "#ccc"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.94619,
    cy: 86.35571,
    r: 2.15765,
    fill: "#ccc"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M524.90227,124.43349a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,524.90227,124.43349Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M533.50285,124.43349a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,533.50285,124.43349Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 313.77725,
    cy: 86.35571,
    r: 2.15765,
    fill: "#ccc"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.37734,
    cy: 86.35571,
    r: 2.15765,
    fill: "#ccc"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.97793,
    cy: 86.35571,
    r: 2.15765,
    fill: "#ccc"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 339.59316,
    cy: 86.35571,
    r: 2.15765,
    fill: "#ccc"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M576.5341,124.43349a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,576.5341,124.43349Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,124.43349a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,688.42863,124.43349Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 86.35571,
    r: 2.15765,
    fill: "#ccc"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 86.35571,
    r: 2.15765,
    fill: "#ccc"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 86.35571,
    r: 2.15765,
    fill: "#ccc"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,128.74867a2.15759,2.15759,0,1,0-2.15771-2.15759A2.15742,2.15742,0,0,0,740.06047,128.74867Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 86.35571,
    r: 2.15765,
    fill: "#ccc"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.75088,
    cy: 86.35571,
    r: 2.15765,
    fill: "#ccc"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,137.349a2.15759,2.15759,0,1,0-2.15723-2.15759A2.15752,2.15752,0,0,0,447.43938,137.349Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M456.04,137.349a2.15759,2.15759,0,1,0-2.15771-2.15759A2.15742,2.15742,0,0,0,456.04,137.349Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.31435,
    cy: 94.95599,
    r: 2.15765,
    fill: "#ccc"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M473.25529,137.349a2.15759,2.15759,0,1,0-2.15722-2.15759A2.15752,2.15752,0,0,0,473.25529,137.349Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M481.871,137.349a2.15759,2.15759,0,1,0-2.15772-2.15759A2.15741,2.15741,0,0,0,481.871,137.349Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.13027,
    cy: 94.95599,
    r: 2.15765,
    fill: "#ccc"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M499.07121,137.349a2.15759,2.15759,0,1,0-2.15722-2.15759A2.15752,2.15752,0,0,0,499.07121,137.349Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.34609,
    cy: 94.95599,
    r: 2.15765,
    fill: "#ccc"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.94619,
    cy: 94.95599,
    r: 2.15765,
    fill: "#ccc"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M524.90227,133.03377a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,524.90227,133.03377Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M533.50285,133.03377a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,533.50285,133.03377Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 313.77725,
    cy: 94.95599,
    r: 2.15765,
    fill: "#ccc"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.37734,
    cy: 94.95599,
    r: 2.15765,
    fill: "#ccc"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.97793,
    cy: 94.95599,
    r: 2.15765,
    fill: "#ccc"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 339.59316,
    cy: 94.95599,
    r: 2.15765,
    fill: "#ccc"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M576.5341,133.03377a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,576.5341,133.03377Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 94.95599,
    r: 2.15765,
    fill: "#ccc"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,133.03377a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,679.81291,133.03377Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,133.03377a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,688.42863,133.03377Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 94.95599,
    r: 2.15765,
    fill: "#ccc"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 94.95599,
    r: 2.15765,
    fill: "#ccc"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,133.03377a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,714.24406,133.03377Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.49844,
    cy: 103.57135,
    r: 2.15765,
    fill: "#ccc"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,145.96431a2.1576,2.1576,0,1,0-2.15723-2.15759A2.15752,2.15752,0,0,0,447.43938,145.96431Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M456.04,145.96431a2.1576,2.1576,0,1,0-2.15771-2.15759A2.15742,2.15742,0,0,0,456.04,145.96431Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.31435,
    cy: 103.57135,
    r: 2.15765,
    fill: "#ccc"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M473.25529,145.96431a2.1576,2.1576,0,1,0-2.15722-2.15759A2.15752,2.15752,0,0,0,473.25529,145.96431Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M481.871,145.96431a2.1576,2.1576,0,1,0-2.15772-2.15759A2.15741,2.15741,0,0,0,481.871,145.96431Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.13027,
    cy: 103.57135,
    r: 2.15765,
    fill: "#ccc"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M499.07121,145.96431a2.1576,2.1576,0,1,0-2.15722-2.15759A2.15752,2.15752,0,0,0,499.07121,145.96431Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.34609,
    cy: 103.57135,
    r: 2.15765,
    fill: "#ccc"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.94619,
    cy: 103.57135,
    r: 2.15765,
    fill: "#ccc"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M524.90227,141.64912a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15742,2.15742,0,0,0,524.90227,141.64912Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M533.50285,141.64912a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,533.50285,141.64912Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 313.77725,
    cy: 103.57135,
    r: 2.15765,
    fill: "#ccc"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.37734,
    cy: 103.57135,
    r: 2.15765,
    fill: "#ccc"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.97793,
    cy: 103.57135,
    r: 2.15765,
    fill: "#ccc"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 339.59316,
    cy: 103.57135,
    r: 2.15765,
    fill: "#ccc"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M576.5341,141.64912a2.1576,2.1576,0,1,0,2.15772,2.1576A2.15742,2.15742,0,0,0,576.5341,141.64912Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,141.64912a2.1576,2.1576,0,1,0,2.15772,2.1576A2.15743,2.15743,0,0,0,679.81291,141.64912Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,141.64912a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,688.42863,141.64912Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 103.57135,
    r: 2.15765,
    fill: "#ccc"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 103.57135,
    r: 2.15765,
    fill: "#ccc"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,150.2494a2.1576,2.1576,0,1,0,2.15722,2.1576A2.15753,2.15753,0,0,0,404.40813,150.2494Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.49844,
    cy: 112.17163,
    r: 2.15765,
    fill: "#ccc"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,154.56459a2.1576,2.1576,0,1,0-2.15723-2.15759A2.15752,2.15752,0,0,0,447.43938,154.56459Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M456.04,154.56459a2.1576,2.1576,0,1,0-2.15771-2.15759A2.15742,2.15742,0,0,0,456.04,154.56459Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.31435,
    cy: 112.17163,
    r: 2.15765,
    fill: "#ccc"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M473.25529,154.56459a2.1576,2.1576,0,1,0-2.15722-2.15759A2.15752,2.15752,0,0,0,473.25529,154.56459Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M481.871,154.56459a2.1576,2.1576,0,1,0-2.15772-2.15759A2.15741,2.15741,0,0,0,481.871,154.56459Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.13027,
    cy: 112.17163,
    r: 2.15765,
    fill: "#ccc"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M499.07121,154.56459A2.1576,2.1576,0,1,0,496.914,152.407,2.15752,2.15752,0,0,0,499.07121,154.56459Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.34609,
    cy: 112.17163,
    r: 2.15765,
    fill: "#ccc"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.94619,
    cy: 112.17163,
    r: 2.15765,
    fill: "#ccc"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M524.90227,150.2494A2.1576,2.1576,0,1,0,527.06,152.407,2.15742,2.15742,0,0,0,524.90227,150.2494Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M533.50285,150.2494a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,533.50285,150.2494Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 313.77725,
    cy: 112.17163,
    r: 2.15765,
    fill: "#ccc"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.37734,
    cy: 112.17163,
    r: 2.15765,
    fill: "#ccc"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.97793,
    cy: 112.17163,
    r: 2.15765,
    fill: "#ccc"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 339.59316,
    cy: 112.17163,
    r: 2.15765,
    fill: "#ccc"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M576.5341,150.2494a2.1576,2.1576,0,1,0,2.15772,2.1576A2.15742,2.15742,0,0,0,576.5341,150.2494Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.9667,
    cy: 112.17163,
    r: 2.15765,
    fill: "#ccc"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.58193,
    cy: 112.17163,
    r: 2.15765,
    fill: "#ccc"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,158.86476a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,395.79289,158.86476Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,158.86476a2.1576,2.1576,0,1,0,2.15722,2.15759A2.15748,2.15748,0,0,0,404.40813,158.86476Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M473.25529,163.18a2.1576,2.1576,0,1,0-2.15722-2.1576A2.15753,2.15753,0,0,0,473.25529,163.18Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M481.871,163.18a2.1576,2.1576,0,1,0-2.15772-2.1576A2.15742,2.15742,0,0,0,481.871,163.18Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.13027,
    cy: 120.78699,
    r: 2.15765,
    fill: "#ccc"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M499.07121,163.18a2.1576,2.1576,0,1,0-2.15722-2.1576A2.15753,2.15753,0,0,0,499.07121,163.18Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.34609,
    cy: 120.78699,
    r: 2.15765,
    fill: "#ccc"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.94619,
    cy: 120.78699,
    r: 2.15765,
    fill: "#ccc"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M524.90227,158.86476a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,524.90227,158.86476Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M533.50285,158.86476a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,533.50285,158.86476Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 313.77725,
    cy: 120.78699,
    r: 2.15765,
    fill: "#ccc"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.37734,
    cy: 120.78699,
    r: 2.15765,
    fill: "#ccc"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.97793,
    cy: 120.78699,
    r: 2.15765,
    fill: "#ccc"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 339.59316,
    cy: 120.78699,
    r: 2.15765,
    fill: "#ccc"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M576.5341,158.86476a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,576.5341,158.86476Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.9667,
    cy: 120.78699,
    r: 2.15765,
    fill: "#ccc"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.85146,
    cy: 129.38727,
    r: 2.15765,
    fill: "#ccc"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,167.465a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,395.79289,167.465Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,167.465a2.1576,2.1576,0,1,0,2.15722,2.15759A2.15753,2.15753,0,0,0,404.40813,167.465Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 129.38727,
    r: 2.15765,
    fill: "#ccc"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M481.871,171.78023a2.1576,2.1576,0,1,0-2.15772-2.1576A2.15738,2.15738,0,0,0,481.871,171.78023Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.13027,
    cy: 129.38727,
    r: 2.15765,
    fill: "#ccc"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M499.07121,171.78023a2.1576,2.1576,0,1,0-2.15722-2.1576A2.15748,2.15748,0,0,0,499.07121,171.78023Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.34609,
    cy: 129.38727,
    r: 2.15765,
    fill: "#ccc"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.94619,
    cy: 129.38727,
    r: 2.15765,
    fill: "#ccc"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M524.90227,167.465a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,524.90227,167.465Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M533.50285,167.465a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,533.50285,167.465Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 313.77725,
    cy: 129.38727,
    r: 2.15765,
    fill: "#ccc"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.37734,
    cy: 129.38727,
    r: 2.15765,
    fill: "#ccc"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.97793,
    cy: 129.38727,
    r: 2.15765,
    fill: "#ccc"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,167.465a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15742,2.15742,0,0,0,791.707,167.465Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.25137,
    cy: 138.00262,
    r: 2.15765,
    fill: "#ccc"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.85146,
    cy: 138.00262,
    r: 2.15765,
    fill: "#ccc"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,176.0804a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,395.79289,176.0804Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,176.0804a2.15759,2.15759,0,1,0,2.15722,2.15759A2.15752,2.15752,0,0,0,404.40813,176.0804Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 138.00262,
    r: 2.15765,
    fill: "#ccc"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,176.0804a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,421.62346,176.0804Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.8832,
    cy: 138.00262,
    r: 2.15765,
    fill: "#ccc"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M481.871,180.39558a2.15759,2.15759,0,1,0-2.15772-2.15759A2.15741,2.15741,0,0,0,481.871,180.39558Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.13027,
    cy: 138.00262,
    r: 2.15765,
    fill: "#ccc"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M499.07121,180.39558A2.15759,2.15759,0,1,0,496.914,178.238,2.15752,2.15752,0,0,0,499.07121,180.39558Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.34609,
    cy: 138.00262,
    r: 2.15765,
    fill: "#ccc"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.94619,
    cy: 138.00262,
    r: 2.15765,
    fill: "#ccc"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M524.90227,176.0804A2.15759,2.15759,0,1,0,527.06,178.238,2.15742,2.15742,0,0,0,524.90227,176.0804Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M533.50285,176.0804a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,533.50285,176.0804Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 313.77725,
    cy: 138.00262,
    r: 2.15765,
    fill: "#ccc"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.37734,
    cy: 138.00262,
    r: 2.15765,
    fill: "#ccc"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.97793,
    cy: 138.00262,
    r: 2.15765,
    fill: "#ccc"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 339.59316,
    cy: 138.00262,
    r: 2.15765,
    fill: "#ccc"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 138.00262,
    r: 2.15765,
    fill: "#ccc"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,176.0804a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,714.24406,176.0804Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,176.0804a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,791.707,176.0804Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M369.97649,184.68068a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,369.97649,184.68068Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.25137,
    cy: 146.60291,
    r: 2.15765,
    fill: "#ccc"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.85146,
    cy: 146.60291,
    r: 2.15765,
    fill: "#ccc"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,184.68068a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,395.79289,184.68068Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 146.60291,
    r: 2.15765,
    fill: "#ccc"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,184.68068a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,421.62346,184.68068Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.8832,
    cy: 146.60291,
    r: 2.15765,
    fill: "#ccc"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.49844,
    cy: 146.60291,
    r: 2.15765,
    fill: "#ccc"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.13027,
    cy: 146.60291,
    r: 2.15765,
    fill: "#ccc"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M499.07121,188.99586a2.15759,2.15759,0,1,0-2.15722-2.15759A2.15752,2.15752,0,0,0,499.07121,188.99586Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.34609,
    cy: 146.60291,
    r: 2.15765,
    fill: "#ccc"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.94619,
    cy: 146.60291,
    r: 2.15765,
    fill: "#ccc"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M524.90227,184.68068a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,524.90227,184.68068Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M533.50285,184.68068a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,533.50285,184.68068Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 313.77725,
    cy: 146.60291,
    r: 2.15765,
    fill: "#ccc"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.37734,
    cy: 146.60291,
    r: 2.15765,
    fill: "#ccc"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.97793,
    cy: 146.60291,
    r: 2.15765,
    fill: "#ccc"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,184.68068a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,688.42863,184.68068Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 146.60291,
    r: 2.15765,
    fill: "#ccc"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 146.60291,
    r: 2.15765,
    fill: "#ccc"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,184.68068a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,714.24406,184.68068Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 146.60291,
    r: 2.15765,
    fill: "#ccc"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 146.60291,
    r: 2.15765,
    fill: "#ccc"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.58193,
    cy: 146.60291,
    r: 2.15765,
    fill: "#ccc"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,184.68068a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,817.52336,184.68068Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.78262,
    cy: 146.60291,
    r: 2.15765,
    fill: "#ccc"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.39785,
    cy: 146.60291,
    r: 2.15765,
    fill: "#ccc"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M369.97649,193.281a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,369.97649,193.281Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.25137,
    cy: 155.20319,
    r: 2.15765,
    fill: "#ccc"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.85146,
    cy: 155.20319,
    r: 2.15765,
    fill: "#ccc"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,193.281a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,395.79289,193.281Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.8832,
    cy: 155.20319,
    r: 2.15765,
    fill: "#ccc"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.49844,
    cy: 155.20319,
    r: 2.15765,
    fill: "#ccc"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,197.59615a2.1576,2.1576,0,1,0-2.15723-2.1576A2.15753,2.15753,0,0,0,447.43938,197.59615Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M456.04,197.59615a2.1576,2.1576,0,1,0-2.15771-2.1576A2.15742,2.15742,0,0,0,456.04,197.59615Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.13027,
    cy: 155.20319,
    r: 2.15765,
    fill: "#ccc"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M499.07121,197.59615a2.1576,2.1576,0,1,0-2.15722-2.1576A2.15753,2.15753,0,0,0,499.07121,197.59615Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.34609,
    cy: 155.20319,
    r: 2.15765,
    fill: "#ccc"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.94619,
    cy: 155.20319,
    r: 2.15765,
    fill: "#ccc"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M524.90227,193.281a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,524.90227,193.281Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M533.50285,193.281a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,533.50285,193.281Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,193.281a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,679.81291,193.281Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,193.281a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,688.42863,193.281Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 155.20319,
    r: 2.15765,
    fill: "#ccc"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 155.20319,
    r: 2.15765,
    fill: "#ccc"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,193.281a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,714.24406,193.281Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 155.20319,
    r: 2.15765,
    fill: "#ccc"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 155.20319,
    r: 2.15765,
    fill: "#ccc"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,193.281a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,740.06047,193.281Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 155.20319,
    r: 2.15765,
    fill: "#ccc"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.75088,
    cy: 155.20319,
    r: 2.15765,
    fill: "#ccc"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,193.281a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,791.707,193.281Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.9667,
    cy: 155.20319,
    r: 2.15765,
    fill: "#ccc"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.58193,
    cy: 155.20319,
    r: 2.15765,
    fill: "#ccc"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,193.281a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,817.52336,193.281Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.78262,
    cy: 155.20319,
    r: 2.15765,
    fill: "#ccc"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.39785,
    cy: 155.20319,
    r: 2.15765,
    fill: "#ccc"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M361.37639,201.89632a2.15762,2.15762,0,1,0,2.15771,2.15765A2.15785,2.15785,0,0,0,361.37639,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M369.97649,201.89632a2.15762,2.15762,0,1,0,2.15771,2.15765A2.15743,2.15743,0,0,0,369.97649,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M378.59221,201.89632a2.15762,2.15762,0,1,0,2.15771,2.15765A2.15753,2.15753,0,0,0,378.59221,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M387.19231,201.89632A2.15762,2.15762,0,1,0,389.35,204.054,2.15785,2.15785,0,0,0,387.19231,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,201.89632a2.15762,2.15762,0,1,0,2.15723,2.15765A2.15753,2.15753,0,0,0,395.79289,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,201.89632a2.15762,2.15762,0,1,0,2.15771,2.15765A2.15743,2.15743,0,0,0,421.62346,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M430.224,201.89632a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15753,2.15753,0,0,0,430.224,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M438.83928,201.89632A2.15762,2.15762,0,1,0,440.997,204.054,2.15785,2.15785,0,0,0,438.83928,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,206.21156a2.15762,2.15762,0,1,0-2.15723-2.15759A2.15752,2.15752,0,0,0,447.43938,206.21156Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M456.04,206.21156a2.15762,2.15762,0,1,0-2.15771-2.15759A2.15742,2.15742,0,0,0,456.04,206.21156Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M490.47111,206.21156a2.15762,2.15762,0,1,0-2.15771-2.15759A2.15752,2.15752,0,0,0,490.47111,206.21156Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M499.07121,206.21156A2.15762,2.15762,0,1,0,496.914,204.054,2.15752,2.15752,0,0,0,499.07121,206.21156Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M507.68693,206.21156a2.15762,2.15762,0,1,0-2.15771-2.15759A2.15783,2.15783,0,0,0,507.68693,206.21156Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M516.287,201.89632a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15784,2.15784,0,0,0,516.287,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M524.90227,201.89632A2.15762,2.15762,0,1,0,527.06,204.054,2.15743,2.15743,0,0,0,524.90227,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M567.934,201.89632a2.15762,2.15762,0,1,0,2.15771,2.15765A2.15753,2.15753,0,0,0,567.934,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M576.5341,201.89632a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15743,2.15743,0,0,0,576.5341,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M585.14983,201.89632a2.15762,2.15762,0,1,0,2.15722,2.15765A2.15753,2.15753,0,0,0,585.14983,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M593.74992,201.89632a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15784,2.15784,0,0,0,593.74992,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M671.21281,201.89632a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15753,2.15753,0,0,0,671.21281,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,201.89632a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15744,2.15744,0,0,0,679.81291,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,201.89632a2.15762,2.15762,0,1,0,2.15723,2.15765A2.15753,2.15753,0,0,0,688.42863,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M697.02873,201.89632a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15753,2.15753,0,0,0,697.02873,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M705.644,201.89632a2.15762,2.15762,0,1,0,2.15771,2.15765A2.15785,2.15785,0,0,0,705.644,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,201.89632a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15743,2.15743,0,0,0,714.24406,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M722.84465,201.89632a2.15762,2.15762,0,1,0,2.15771,2.15765A2.15754,2.15754,0,0,0,722.84465,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M774.49162,201.89632a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15753,2.15753,0,0,0,774.49162,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M783.09172,201.89632a2.15762,2.15762,0,1,0,2.15771,2.15765A2.15784,2.15784,0,0,0,783.09172,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,201.89632a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15743,2.15743,0,0,0,791.707,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M800.30754,201.89632a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15753,2.15753,0,0,0,800.30754,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M808.92277,201.89632a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15784,2.15784,0,0,0,808.92277,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,201.89632a2.15762,2.15762,0,1,0,2.15723,2.15765A2.15753,2.15753,0,0,0,817.52336,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M826.12346,201.89632a2.15762,2.15762,0,1,0,2.15771,2.15765A2.15753,2.15753,0,0,0,826.12346,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M834.73869,201.89632a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15784,2.15784,0,0,0,834.73869,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,201.89632a2.15762,2.15762,0,1,0,2.15723,2.15765A2.15753,2.15753,0,0,0,843.33928,201.89632Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.42031,
    cy: 172.41882,
    r: 2.15765,
    fill: "#ccc"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.03555,
    cy: 172.41882,
    r: 2.15765,
    fill: "#ccc"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M369.97649,210.4966a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,369.97649,210.4966Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.25137,
    cy: 172.41882,
    r: 2.15765,
    fill: "#ccc"
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.85146,
    cy: 172.41882,
    r: 2.15765,
    fill: "#ccc"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,210.4966a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,395.79289,210.4966Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.8832,
    cy: 172.41882,
    r: 2.15765,
    fill: "#ccc"
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.49844,
    cy: 172.41882,
    r: 2.15765,
    fill: "#ccc"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,214.81178a2.15759,2.15759,0,1,0-2.15723-2.15759A2.15752,2.15752,0,0,0,447.43938,214.81178Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.13027,
    cy: 172.41882,
    r: 2.15765,
    fill: "#ccc"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M499.07121,214.81178a2.15759,2.15759,0,1,0-2.15722-2.15759A2.15752,2.15752,0,0,0,499.07121,214.81178Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.34609,
    cy: 172.41882,
    r: 2.15765,
    fill: "#ccc"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M576.5341,210.4966a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,576.5341,210.4966Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M585.14983,210.4966a2.15759,2.15759,0,1,0,2.15722,2.15759A2.15752,2.15752,0,0,0,585.14983,210.4966Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,210.4966a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,662.59758,210.4966Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 172.41882,
    r: 2.15765,
    fill: "#ccc"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,210.4966a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15742,2.15742,0,0,0,679.81291,210.4966Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,210.4966a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,688.42863,210.4966Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 172.41882,
    r: 2.15765,
    fill: "#ccc"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,210.4966a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,714.24406,210.4966Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 172.41882,
    r: 2.15765,
    fill: "#ccc"
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 172.41882,
    r: 2.15765,
    fill: "#ccc"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,210.4966a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,748.6757,210.4966Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,210.4966a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,765.89152,210.4966Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 172.41882,
    r: 2.15765,
    fill: "#ccc"
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.75088,
    cy: 172.41882,
    r: 2.15765,
    fill: "#ccc"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,210.4966a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,791.707,210.4966Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.9667,
    cy: 172.41882,
    r: 2.15765,
    fill: "#ccc"
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.58193,
    cy: 172.41882,
    r: 2.15765,
    fill: "#ccc"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,210.4966a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,817.52336,210.4966Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.78262,
    cy: 172.41882,
    r: 2.15765,
    fill: "#ccc"
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.39785,
    cy: 172.41882,
    r: 2.15765,
    fill: "#ccc"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,210.4966a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,843.33928,210.4966Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.61367,
    cy: 172.41882,
    r: 2.15765,
    fill: "#ccc"
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.42031,
    cy: 181.03418,
    r: 2.15765,
    fill: "#ccc"
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.03555,
    cy: 181.03418,
    r: 2.15765,
    fill: "#ccc"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M369.97649,219.112a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15742,2.15742,0,0,0,369.97649,219.112Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 181.03418,
    r: 2.15765,
    fill: "#ccc"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,219.112a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15742,2.15742,0,0,0,421.62346,219.112Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.49844,
    cy: 181.03418,
    r: 2.15765,
    fill: "#ccc"
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.13027,
    cy: 181.03418,
    r: 2.15765,
    fill: "#ccc"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M499.07121,223.42714a2.1576,2.1576,0,1,0-2.15722-2.15759A2.15752,2.15752,0,0,0,499.07121,223.42714Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.34609,
    cy: 181.03418,
    r: 2.15765,
    fill: "#ccc"
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.65615,
    cy: 181.03418,
    r: 2.15765,
    fill: "#ccc"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,219.112a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,662.59758,219.112Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 181.03418,
    r: 2.15765,
    fill: "#ccc"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,219.112a2.1576,2.1576,0,1,0,2.15772,2.1576A2.15743,2.15743,0,0,0,679.81291,219.112Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 181.03418,
    r: 2.15765,
    fill: "#ccc"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,219.112a2.1576,2.1576,0,1,0,2.15772,2.1576A2.15742,2.15742,0,0,0,714.24406,219.112Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 181.03418,
    r: 2.15765,
    fill: "#ccc"
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 181.03418,
    r: 2.15765,
    fill: "#ccc"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,219.112a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,740.06047,219.112Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,219.112a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,748.6757,219.112Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.93496,
    cy: 181.03418,
    r: 2.15765,
    fill: "#ccc"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,219.112a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,765.89152,219.112Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 181.03418,
    r: 2.15765,
    fill: "#ccc"
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.75088,
    cy: 181.03418,
    r: 2.15765,
    fill: "#ccc"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,219.112a2.1576,2.1576,0,1,0,2.15772,2.1576A2.15742,2.15742,0,0,0,791.707,219.112Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.9667,
    cy: 181.03418,
    r: 2.15765,
    fill: "#ccc"
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.58193,
    cy: 181.03418,
    r: 2.15765,
    fill: "#ccc"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,219.112a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,817.52336,219.112Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.78262,
    cy: 181.03418,
    r: 2.15765,
    fill: "#ccc"
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.39785,
    cy: 181.03418,
    r: 2.15765,
    fill: "#ccc"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,219.112a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,843.33928,219.112Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.61367,
    cy: 181.03418,
    r: 2.15765,
    fill: "#ccc"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M344.16057,227.71223a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15742,2.15742,0,0,0,344.16057,227.71223Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.42031,
    cy: 189.63446,
    r: 2.15765,
    fill: "#ccc"
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.03555,
    cy: 189.63446,
    r: 2.15765,
    fill: "#ccc"
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 189.63446,
    r: 2.15765,
    fill: "#ccc"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,227.71223a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15742,2.15742,0,0,0,421.62346,227.71223Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.8832,
    cy: 189.63446,
    r: 2.15765,
    fill: "#ccc"
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.34609,
    cy: 189.63446,
    r: 2.15765,
    fill: "#ccc"
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.225,
    cy: 189.63446,
    r: 2.15765,
    fill: "#ccc"
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.84023,
    cy: 189.63446,
    r: 2.15765,
    fill: "#ccc"
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.65615,
    cy: 189.63446,
    r: 2.15765,
    fill: "#ccc"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,227.71223a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,662.59758,227.71223Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 189.63446,
    r: 2.15765,
    fill: "#ccc"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,227.71223a2.1576,2.1576,0,1,0,2.15772,2.1576A2.15743,2.15743,0,0,0,679.81291,227.71223Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 189.63446,
    r: 2.15765,
    fill: "#ccc"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,227.71223a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,740.06047,227.71223Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,227.71223a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,748.6757,227.71223Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.93496,
    cy: 189.63446,
    r: 2.15765,
    fill: "#ccc"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,227.71223a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,765.89152,227.71223Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 189.63446,
    r: 2.15765,
    fill: "#ccc"
  })), _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.75088,
    cy: 189.63446,
    r: 2.15765,
    fill: "#ccc"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,227.71223a2.1576,2.1576,0,1,0,2.15772,2.1576A2.15742,2.15742,0,0,0,791.707,227.71223Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle166 || (_circle166 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.9667,
    cy: 189.63446,
    r: 2.15765,
    fill: "#ccc"
  })), _circle167 || (_circle167 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.58193,
    cy: 189.63446,
    r: 2.15765,
    fill: "#ccc"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,227.71223a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,817.52336,227.71223Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle168 || (_circle168 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.78262,
    cy: 189.63446,
    r: 2.15765,
    fill: "#ccc"
  })), _circle169 || (_circle169 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.39785,
    cy: 189.63446,
    r: 2.15765,
    fill: "#ccc"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,227.71223a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,843.33928,227.71223Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle170 || (_circle170 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.61367,
    cy: 189.63446,
    r: 2.15765,
    fill: "#ccc"
  })), _circle171 || (_circle171 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.21377,
    cy: 189.63446,
    r: 2.15765,
    fill: "#ccc"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M344.16057,236.31252a2.15762,2.15762,0,1,0,2.15771,2.15765A2.15743,2.15743,0,0,0,344.16057,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M352.76115,236.31252a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15753,2.15753,0,0,0,352.76115,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M361.37639,236.31252a2.15762,2.15762,0,1,0,2.15771,2.15765A2.15785,2.15785,0,0,0,361.37639,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M369.97649,236.31252a2.15762,2.15762,0,1,0,2.15771,2.15765A2.15743,2.15743,0,0,0,369.97649,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M413.00822,236.31252a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15784,2.15784,0,0,0,413.00822,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,236.31252a2.15762,2.15762,0,1,0,2.15771,2.15765A2.15743,2.15743,0,0,0,421.62346,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M430.224,236.31252a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15753,2.15753,0,0,0,430.224,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M438.83928,236.31252a2.15762,2.15762,0,1,0,2.15771,2.15765A2.15785,2.15785,0,0,0,438.83928,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M619.56584,236.31252a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15753,2.15753,0,0,0,619.56584,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M628.18108,236.31252a2.15762,2.15762,0,1,0,2.15771,2.15765A2.15785,2.15785,0,0,0,628.18108,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M653.997,236.31252a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15784,2.15784,0,0,0,653.997,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M671.21281,236.31252a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15753,2.15753,0,0,0,671.21281,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,236.31252a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15744,2.15744,0,0,0,679.81291,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M705.644,236.31252a2.15762,2.15762,0,1,0,2.15771,2.15765A2.15785,2.15785,0,0,0,705.644,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,236.31252a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15743,2.15743,0,0,0,714.24406,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M722.84465,236.31252a2.15762,2.15762,0,1,0,2.15771,2.15765A2.15754,2.15754,0,0,0,722.84465,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M731.45988,236.31252a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15784,2.15784,0,0,0,731.45988,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,236.31252a2.15762,2.15762,0,1,0,2.15723,2.15765A2.15753,2.15753,0,0,0,740.06047,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,236.31252a2.15762,2.15762,0,1,0,2.15723,2.15765A2.15753,2.15753,0,0,0,748.6757,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M757.2758,236.31252a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15784,2.15784,0,0,0,757.2758,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,236.31252a2.15762,2.15762,0,1,0,2.15723,2.15765A2.15753,2.15753,0,0,0,765.89152,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M774.49162,236.31252a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15753,2.15753,0,0,0,774.49162,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M783.09172,236.31252a2.15762,2.15762,0,1,0,2.15771,2.15765A2.15784,2.15784,0,0,0,783.09172,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,236.31252a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15743,2.15743,0,0,0,791.707,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M800.30754,236.31252a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15753,2.15753,0,0,0,800.30754,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M808.92277,236.31252a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15784,2.15784,0,0,0,808.92277,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,236.31252a2.15762,2.15762,0,1,0,2.15723,2.15765A2.15753,2.15753,0,0,0,817.52336,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M826.12346,236.31252a2.15762,2.15762,0,1,0,2.15771,2.15765A2.15753,2.15753,0,0,0,826.12346,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M834.73869,236.31252a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15784,2.15784,0,0,0,834.73869,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,236.31252a2.15762,2.15762,0,1,0,2.15723,2.15765A2.15753,2.15753,0,0,0,843.33928,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M851.95451,236.31252a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15753,2.15753,0,0,0,851.95451,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M860.55461,236.31252a2.15762,2.15762,0,1,0,2.15772,2.15765A2.15784,2.15784,0,0,0,860.55461,236.31252Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M344.16057,244.92787a2.15763,2.15763,0,1,0,2.15771,2.15766A2.15743,2.15743,0,0,0,344.16057,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M352.76115,244.92787a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15753,2.15753,0,0,0,352.76115,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M361.37639,244.92787a2.15763,2.15763,0,1,0,2.15771,2.15766A2.15785,2.15785,0,0,0,361.37639,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M369.97649,244.92787a2.15763,2.15763,0,1,0,2.15771,2.15766A2.15743,2.15743,0,0,0,369.97649,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M378.59221,244.92787a2.15763,2.15763,0,1,0,2.15771,2.15766A2.15754,2.15754,0,0,0,378.59221,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M413.00822,244.92787a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15785,2.15785,0,0,0,413.00822,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,244.92787a2.15763,2.15763,0,1,0,2.15771,2.15766A2.15743,2.15743,0,0,0,421.62346,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M430.224,244.92787a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15753,2.15753,0,0,0,430.224,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M438.83928,244.92787a2.15763,2.15763,0,1,0,2.15771,2.15766A2.15785,2.15785,0,0,0,438.83928,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,244.92787a2.15763,2.15763,0,1,0,2.00537,2.942c1.50976,2.45623,3.11767,4.79425,4.65527,6.8872a2.13657,2.13657,0,0,0,2.31494,3.04853c2.917,3.72186,5.14209,6.13586,5.14209,6.13586s17.93164-19.46985,18.76758-33.25116c.02979-.34338.04541-.67181.04541-1.0003A18.69963,18.69963,0,0,0,464.498,211.44441a19.07013,19.07013,0,0,0-2.94092-.209,19.66014,19.66014,0,0,0-2.98633.209,18.74069,18.74069,0,0,0-6.61474,2.359,14.54442,14.54442,0,0,0-1.792,1.20941,18.58017,18.58017,0,0,0-7.4502,14.67713c0,.32849.01563.65692.04443,1.0003.27,4.44605,2.32569,9.48255,4.98243,14.268A2.13251,2.13251,0,0,0,447.43938,244.92787Zm14.37109-21.85229A6.59653,6.59653,0,0,1,468.2758,229.69a6.23435,6.23435,0,0,1-.08984,1.07507,6.596,6.596,0,0,1-6.46533,5.56915h-.16358v-.05975a6.581,6.581,0,0,1-6.37549-5.55426,4.91554,4.91554,0,0,1-.08984-1.16467A6.60262,6.60262,0,0,1,461.81047,223.07558Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ff6584"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M619.56584,244.92787a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15753,2.15753,0,0,0,619.56584,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M628.18108,244.92787a2.15763,2.15763,0,1,0,2.15771,2.15766A2.15785,2.15785,0,0,0,628.18108,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,244.92787a2.15763,2.15763,0,1,0,2.15723,2.15766A2.15754,2.15754,0,0,0,662.59758,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M697.02873,244.92787a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15753,2.15753,0,0,0,697.02873,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M705.644,244.92787a2.15763,2.15763,0,1,0,2.15771,2.15766A2.15785,2.15785,0,0,0,705.644,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,244.92787a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15743,2.15743,0,0,0,714.24406,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M722.84465,244.92787a2.15763,2.15763,0,1,0,2.15771,2.15766A2.15754,2.15754,0,0,0,722.84465,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M731.45988,244.92787a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15785,2.15785,0,0,0,731.45988,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,244.92787a2.15763,2.15763,0,1,0,2.15723,2.15766A2.15753,2.15753,0,0,0,740.06047,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,244.92787a2.15763,2.15763,0,1,0,2.15723,2.15766A2.15753,2.15753,0,0,0,748.6757,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M757.2758,244.92787a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15785,2.15785,0,0,0,757.2758,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,244.92787a2.15763,2.15763,0,1,0,2.15723,2.15766A2.15753,2.15753,0,0,0,765.89152,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M774.49162,244.92787a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15753,2.15753,0,0,0,774.49162,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M783.09172,244.92787a2.15763,2.15763,0,1,0,2.15771,2.15766A2.15784,2.15784,0,0,0,783.09172,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,244.92787a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15743,2.15743,0,0,0,791.707,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M800.30754,244.92787a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15753,2.15753,0,0,0,800.30754,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M808.92277,244.92787a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15785,2.15785,0,0,0,808.92277,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,244.92787a2.15763,2.15763,0,1,0,2.15723,2.15766A2.15753,2.15753,0,0,0,817.52336,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M826.12346,244.92787a2.15763,2.15763,0,1,0,2.15771,2.15766A2.15754,2.15754,0,0,0,826.12346,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M834.73869,244.92787a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15785,2.15785,0,0,0,834.73869,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,244.92787a2.15763,2.15763,0,1,0,2.15723,2.15766A2.15754,2.15754,0,0,0,843.33928,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M851.95451,244.92787a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15753,2.15753,0,0,0,851.95451,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M860.55461,244.92787a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15784,2.15784,0,0,0,860.55461,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M869.16985,244.92787a2.15763,2.15763,0,1,0,2.15771,2.15766A2.15743,2.15743,0,0,0,869.16985,244.92787Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle172 || (_circle172 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.21963,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M344.16057,253.52821a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15739,2.15739,0,0,0,344.16057,253.52821Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle173 || (_circle173 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.42031,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _circle174 || (_circle174 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.03555,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M369.97649,253.52821a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15739,2.15739,0,0,0,369.97649,253.52821Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle175 || (_circle175 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.25137,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _circle176 || (_circle176 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.85146,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,253.52821a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15749,2.15749,0,0,0,395.79289,253.52821Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle177 || (_circle177 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,253.52821a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15739,2.15739,0,0,0,421.62346,253.52821Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle178 || (_circle178 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.8832,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _circle179 || (_circle179 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.49844,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,253.52821a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15739,2.15739,0,0,0,447.43938,253.52821Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M610.96574,253.52821a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15749,2.15749,0,0,0,610.96574,253.52821Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle180 || (_circle180 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.84023,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,253.52821a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15749,2.15749,0,0,0,662.59758,253.52821Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,253.52821a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15749,2.15749,0,0,0,688.42863,253.52821Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle181 || (_circle181 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _circle182 || (_circle182 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,253.52821a2.1576,2.1576,0,1,0,2.15772,2.1576A2.15738,2.15738,0,0,0,714.24406,253.52821Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle183 || (_circle183 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _circle184 || (_circle184 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,253.52821a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15749,2.15749,0,0,0,740.06047,253.52821Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,253.52821a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15749,2.15749,0,0,0,748.6757,253.52821Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle185 || (_circle185 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.93496,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,253.52821a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15749,2.15749,0,0,0,765.89152,253.52821Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle186 || (_circle186 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _circle187 || (_circle187 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.75088,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,253.52821a2.1576,2.1576,0,1,0,2.15772,2.1576A2.15738,2.15738,0,0,0,791.707,253.52821Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle188 || (_circle188 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.9667,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _circle189 || (_circle189 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.58193,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,253.52821a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15749,2.15749,0,0,0,817.52336,253.52821Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle190 || (_circle190 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.78262,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _circle191 || (_circle191 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.39785,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,253.52821a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15749,2.15749,0,0,0,843.33928,253.52821Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle192 || (_circle192 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.61367,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _circle193 || (_circle193 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.21377,
    cy: 215.45044,
    r: 2.15765,
    fill: "#ccc"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M869.16985,253.52821a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15739,2.15739,0,0,0,869.16985,253.52821Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle194 || (_circle194 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.21963,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M344.16057,262.14357a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,344.16057,262.14357Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle195 || (_circle195 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.42031,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _circle196 || (_circle196 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.03555,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M369.97649,262.14357a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,369.97649,262.14357Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle197 || (_circle197 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.25137,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _circle198 || (_circle198 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.85146,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,262.14357a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,395.79289,262.14357Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle199 || (_circle199 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,262.14357a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,421.62346,262.14357Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle200 || (_circle200 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.8832,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _circle201 || (_circle201 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.49844,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,262.14357a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,447.43938,262.14357Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M456.04,262.14357a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,456.04,262.14357Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle202 || (_circle202 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.31435,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M473.25529,262.14357a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,473.25529,262.14357Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M610.96574,262.14357a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,610.96574,262.14357Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle203 || (_circle203 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.84023,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M636.78166,262.14357a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,636.78166,262.14357Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle204 || (_circle204 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.65615,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,262.14357a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,662.59758,262.14357Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle205 || (_circle205 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,262.14357a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,679.81291,262.14357Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,262.14357a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,688.42863,262.14357Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle206 || (_circle206 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _circle207 || (_circle207 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,262.14357a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,714.24406,262.14357Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle208 || (_circle208 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _circle209 || (_circle209 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,262.14357a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,740.06047,262.14357Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,262.14357a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,748.6757,262.14357Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle210 || (_circle210 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.93496,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,262.14357a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,765.89152,262.14357Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle211 || (_circle211 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _circle212 || (_circle212 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.75088,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,262.14357a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,791.707,262.14357Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle213 || (_circle213 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.9667,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _circle214 || (_circle214 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.58193,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,262.14357a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,817.52336,262.14357Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle215 || (_circle215 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.78262,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _circle216 || (_circle216 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.39785,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,262.14357a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,843.33928,262.14357Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle217 || (_circle217 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.61367,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _circle218 || (_circle218 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.21377,
    cy: 224.0658,
    r: 2.15765,
    fill: "#ccc"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M869.16985,262.14357a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,869.16985,262.14357Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle219 || (_circle219 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.21963,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M344.16057,270.74379a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,344.16057,270.74379Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle220 || (_circle220 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.42031,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _circle221 || (_circle221 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.03555,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M369.97649,270.74379a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,369.97649,270.74379Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle222 || (_circle222 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.25137,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _circle223 || (_circle223 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.85146,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,270.74379a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,395.79289,270.74379Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,270.74379a2.1576,2.1576,0,1,0,2.15722,2.15759A2.15752,2.15752,0,0,0,404.40813,270.74379Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle224 || (_circle224 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,270.74379a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,421.62346,270.74379Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle225 || (_circle225 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.8832,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _circle226 || (_circle226 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.49844,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,270.74379a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,447.43938,270.74379Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M456.04,270.74379a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,456.04,270.74379Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M473.25529,270.74379a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,473.25529,270.74379Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle227 || (_circle227 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.05605,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _circle228 || (_circle228 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.65615,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,270.74379a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,662.59758,270.74379Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle229 || (_circle229 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,270.74379a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15742,2.15742,0,0,0,679.81291,270.74379Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,270.74379a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,688.42863,270.74379Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle230 || (_circle230 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _circle231 || (_circle231 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,270.74379a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,714.24406,270.74379Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle232 || (_circle232 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _circle233 || (_circle233 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,270.74379a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,740.06047,270.74379Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,270.74379a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,748.6757,270.74379Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle234 || (_circle234 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.93496,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,270.74379a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,765.89152,270.74379Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle235 || (_circle235 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _circle236 || (_circle236 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.75088,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,270.74379a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,791.707,270.74379Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle237 || (_circle237 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.9667,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _circle238 || (_circle238 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.58193,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,270.74379a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,817.52336,270.74379Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle239 || (_circle239 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.78262,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _circle240 || (_circle240 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.39785,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,270.74379a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,843.33928,270.74379Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle241 || (_circle241 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.61367,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _circle242 || (_circle242 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.21377,
    cy: 232.66602,
    r: 2.15765,
    fill: "#ccc"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M869.16985,270.74379a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,869.16985,270.74379Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M877.77043,270.74379a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,877.77043,270.74379Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M326.94524,279.35921a2.15759,2.15759,0,1,0,2.15722,2.15759A2.15752,2.15752,0,0,0,326.94524,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle243 || (_circle243 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.21963,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M344.16057,279.35921a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,344.16057,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle244 || (_circle244 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.42031,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _circle245 || (_circle245 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.03555,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M369.97649,279.35921a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,369.97649,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle246 || (_circle246 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.25137,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _circle247 || (_circle247 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.85146,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,279.35921a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,395.79289,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,279.35921a2.15759,2.15759,0,1,0,2.15722,2.15759A2.15752,2.15752,0,0,0,404.40813,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle248 || (_circle248 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,279.35921a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,421.62346,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle249 || (_circle249 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.8832,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _circle250 || (_circle250 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.49844,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,279.35921a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,447.43938,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle251 || (_circle251 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.31435,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M473.25529,279.35921a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,473.25529,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M481.871,279.35921a2.15759,2.15759,0,1,0,2.15722,2.15759A2.15752,2.15752,0,0,0,481.871,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle252 || (_circle252 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.84023,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M636.78166,279.35921a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,636.78166,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle253 || (_circle253 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.05605,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _circle254 || (_circle254 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.65615,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,279.35921a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,662.59758,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle255 || (_circle255 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,279.35921a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15742,2.15742,0,0,0,679.81291,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,279.35921a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,688.42863,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle256 || (_circle256 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _circle257 || (_circle257 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,279.35921a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,714.24406,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle258 || (_circle258 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _circle259 || (_circle259 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,279.35921a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,740.06047,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,279.35921a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,748.6757,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle260 || (_circle260 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.93496,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,279.35921a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,765.89152,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle261 || (_circle261 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _circle262 || (_circle262 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.75088,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,279.35921a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,791.707,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle263 || (_circle263 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.9667,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _circle264 || (_circle264 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.58193,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,279.35921a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,817.52336,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle265 || (_circle265 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.78262,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _circle266 || (_circle266 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.39785,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,279.35921a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,843.33928,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle267 || (_circle267 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.61367,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _circle268 || (_circle268 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.21377,
    cy: 241.28143,
    r: 2.15765,
    fill: "#ccc"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M869.16985,279.35921a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,869.16985,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M877.77043,279.35921a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,877.77043,279.35921Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M326.94524,287.95943a2.15762,2.15762,0,1,0,2.15722,2.15759A2.15752,2.15752,0,0,0,326.94524,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M335.56047,287.95943a2.15762,2.15762,0,1,0,2.15771,2.15759A2.15783,2.15783,0,0,0,335.56047,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M344.16057,287.95943a2.15762,2.15762,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,344.16057,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M352.76115,287.95943a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15752,2.15752,0,0,0,352.76115,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M361.37639,287.95943a2.15762,2.15762,0,1,0,2.15771,2.15759A2.15783,2.15783,0,0,0,361.37639,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M369.97649,287.95943a2.15762,2.15762,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,369.97649,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M378.59221,287.95943a2.15762,2.15762,0,1,0,2.15771,2.15759A2.15752,2.15752,0,0,0,378.59221,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M387.19231,287.95943A2.15762,2.15762,0,1,0,389.35,290.117,2.15783,2.15783,0,0,0,387.19231,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,287.95943a2.15762,2.15762,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,395.79289,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,287.95943a2.15762,2.15762,0,1,0,2.15722,2.15759A2.15752,2.15752,0,0,0,404.40813,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M413.00822,287.95943a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15783,2.15783,0,0,0,413.00822,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,287.95943a2.15762,2.15762,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,421.62346,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M430.224,287.95943a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15752,2.15752,0,0,0,430.224,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M438.83928,287.95943A2.15762,2.15762,0,1,0,440.997,290.117,2.15783,2.15783,0,0,0,438.83928,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,287.95943a2.15762,2.15762,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,447.43938,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M456.04,287.95943a2.15762,2.15762,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,456.04,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M636.78166,287.95943a2.15762,2.15762,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,636.78166,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M645.3969,287.95943a2.15762,2.15762,0,1,0,2.15771,2.15759A2.15752,2.15752,0,0,0,645.3969,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M653.997,287.95943a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15783,2.15783,0,0,0,653.997,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,287.95943a2.15762,2.15762,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,662.59758,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M671.21281,287.95943a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15752,2.15752,0,0,0,671.21281,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,287.95943a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15742,2.15742,0,0,0,679.81291,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,287.95943a2.15762,2.15762,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,688.42863,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M697.02873,287.95943a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15752,2.15752,0,0,0,697.02873,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M705.644,287.95943a2.15762,2.15762,0,1,0,2.15771,2.15759A2.15783,2.15783,0,0,0,705.644,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,287.95943a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,714.24406,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M722.84465,287.95943a2.15762,2.15762,0,1,0,2.15771,2.15759A2.15753,2.15753,0,0,0,722.84465,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M731.45988,287.95943a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15783,2.15783,0,0,0,731.45988,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,287.95943a2.15762,2.15762,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,740.06047,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,287.95943a2.15762,2.15762,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,748.6757,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M757.2758,287.95943a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15783,2.15783,0,0,0,757.2758,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,287.95943a2.15762,2.15762,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,765.89152,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M774.49162,287.95943a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15752,2.15752,0,0,0,774.49162,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M783.09172,287.95943a2.15762,2.15762,0,1,0,2.15771,2.15759A2.15783,2.15783,0,0,0,783.09172,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,287.95943a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,791.707,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M800.30754,287.95943a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15752,2.15752,0,0,0,800.30754,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M808.92277,287.95943a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15783,2.15783,0,0,0,808.92277,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,287.95943a2.15762,2.15762,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,817.52336,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M826.12346,287.95943a2.15762,2.15762,0,1,0,2.15771,2.15759A2.15752,2.15752,0,0,0,826.12346,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M834.73869,287.95943a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15783,2.15783,0,0,0,834.73869,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,287.95943a2.15762,2.15762,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,843.33928,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M851.95451,287.95943a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15752,2.15752,0,0,0,851.95451,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M860.55461,287.95943a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15783,2.15783,0,0,0,860.55461,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M869.16985,287.95943a2.15762,2.15762,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,869.16985,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M877.77043,287.95943a2.15762,2.15762,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,877.77043,287.95943Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M326.94524,296.55977a2.15759,2.15759,0,1,0,2.15722,2.15759A2.15748,2.15748,0,0,0,326.94524,296.55977Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle269 || (_circle269 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.21963,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M344.16057,296.55977a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,344.16057,296.55977Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle270 || (_circle270 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.42031,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _circle271 || (_circle271 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.03555,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M369.97649,296.55977a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,369.97649,296.55977Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle272 || (_circle272 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.25137,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _circle273 || (_circle273 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.85146,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,296.55977a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,395.79289,296.55977Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,296.55977a2.15759,2.15759,0,1,0,2.15722,2.15759A2.15748,2.15748,0,0,0,404.40813,296.55977Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle274 || (_circle274 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,296.55977a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,421.62346,296.55977Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle275 || (_circle275 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.8832,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,296.55977a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,447.43938,296.55977Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M610.96574,296.55977a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,610.96574,296.55977Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle276 || (_circle276 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.225,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _circle277 || (_circle277 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.84023,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M636.78166,296.55977a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,636.78166,296.55977Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle278 || (_circle278 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.05605,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _circle279 || (_circle279 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.65615,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _circle280 || (_circle280 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,296.55977a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,688.42863,296.55977Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle281 || (_circle281 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _circle282 || (_circle282 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,296.55977a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,714.24406,296.55977Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle283 || (_circle283 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _circle284 || (_circle284 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,296.55977a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,740.06047,296.55977Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,296.55977a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,748.6757,296.55977Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle285 || (_circle285 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.93496,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,296.55977a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,765.89152,296.55977Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle286 || (_circle286 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _circle287 || (_circle287 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.75088,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,296.55977a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,791.707,296.55977Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle288 || (_circle288 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.9667,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _circle289 || (_circle289 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.58193,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,296.55977a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,817.52336,296.55977Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle290 || (_circle290 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.78262,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _circle291 || (_circle291 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.39785,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,296.55977a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,843.33928,296.55977Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle292 || (_circle292 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.61367,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _circle293 || (_circle293 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.21377,
    cy: 258.48199,
    r: 2.15765,
    fill: "#ccc"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M869.16985,296.55977a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,869.16985,296.55977Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M877.77043,296.55977a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,877.77043,296.55977Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M326.94524,305.17512a2.1576,2.1576,0,1,0,2.15722,2.1576A2.15749,2.15749,0,0,0,326.94524,305.17512Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle294 || (_circle294 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.21963,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M344.16057,305.17512a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15739,2.15739,0,0,0,344.16057,305.17512Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle295 || (_circle295 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.42031,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _circle296 || (_circle296 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.03555,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M369.97649,305.17512a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15739,2.15739,0,0,0,369.97649,305.17512Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle297 || (_circle297 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.25137,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _circle298 || (_circle298 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.85146,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,305.17512a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15749,2.15749,0,0,0,395.79289,305.17512Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,305.17512a2.1576,2.1576,0,1,0,2.15722,2.1576A2.15749,2.15749,0,0,0,404.40813,305.17512Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle299 || (_circle299 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,305.17512a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15739,2.15739,0,0,0,421.62346,305.17512Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle300 || (_circle300 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.8832,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M610.96574,305.17512a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15749,2.15749,0,0,0,610.96574,305.17512Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle301 || (_circle301 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.225,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _circle302 || (_circle302 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.84023,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M636.78166,305.17512a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15749,2.15749,0,0,0,636.78166,305.17512Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle303 || (_circle303 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,305.17512a2.1576,2.1576,0,1,0,2.15772,2.1576A2.15739,2.15739,0,0,0,679.81291,305.17512Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle304 || (_circle304 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _circle305 || (_circle305 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,305.17512a2.1576,2.1576,0,1,0,2.15772,2.1576A2.15738,2.15738,0,0,0,714.24406,305.17512Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle306 || (_circle306 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _circle307 || (_circle307 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,305.17512a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15749,2.15749,0,0,0,740.06047,305.17512Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,305.17512a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15749,2.15749,0,0,0,748.6757,305.17512Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle308 || (_circle308 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.93496,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,305.17512a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15749,2.15749,0,0,0,765.89152,305.17512Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle309 || (_circle309 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _circle310 || (_circle310 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.75088,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,305.17512a2.1576,2.1576,0,1,0,2.15772,2.1576A2.15738,2.15738,0,0,0,791.707,305.17512Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle311 || (_circle311 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.9667,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _circle312 || (_circle312 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.58193,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,305.17512a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15749,2.15749,0,0,0,817.52336,305.17512Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle313 || (_circle313 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.78262,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _circle314 || (_circle314 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.39785,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,305.17512a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15749,2.15749,0,0,0,843.33928,305.17512Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle315 || (_circle315 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.61367,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _circle316 || (_circle316 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.21377,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M869.16985,305.17512a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15739,2.15739,0,0,0,869.16985,305.17512Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M877.77043,305.17512a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15749,2.15749,0,0,0,877.77043,305.17512Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle317 || (_circle317 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.02969,
    cy: 267.09735,
    r: 2.15765,
    fill: "#ccc"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M326.94524,313.77541a2.15759,2.15759,0,1,0,2.15722,2.15759A2.15752,2.15752,0,0,0,326.94524,313.77541Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle318 || (_circle318 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.21963,
    cy: 275.69763,
    r: 2.15765,
    fill: "#ccc"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M344.16057,313.77541a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,344.16057,313.77541Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle319 || (_circle319 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.42031,
    cy: 275.69763,
    r: 2.15765,
    fill: "#ccc"
  })), _circle320 || (_circle320 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.03555,
    cy: 275.69763,
    r: 2.15765,
    fill: "#ccc"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M369.97649,313.77541a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,369.97649,313.77541Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle321 || (_circle321 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.25137,
    cy: 275.69763,
    r: 2.15765,
    fill: "#ccc"
  })), _circle322 || (_circle322 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.85146,
    cy: 275.69763,
    r: 2.15765,
    fill: "#ccc"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,313.77541a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,395.79289,313.77541Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,313.77541a2.15759,2.15759,0,1,0,2.15722,2.15759A2.15752,2.15752,0,0,0,404.40813,313.77541Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle323 || (_circle323 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 275.69763,
    r: 2.15765,
    fill: "#ccc"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M610.96574,313.77541A2.15759,2.15759,0,1,0,613.123,315.933,2.15752,2.15752,0,0,0,610.96574,313.77541Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle324 || (_circle324 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.225,
    cy: 275.69763,
    r: 2.15765,
    fill: "#ccc"
  })), _circle325 || (_circle325 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.84023,
    cy: 275.69763,
    r: 2.15765,
    fill: "#ccc"
  })), _circle326 || (_circle326 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 275.69763,
    r: 2.15765,
    fill: "#ccc"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,313.77541a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,714.24406,313.77541Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle327 || (_circle327 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 275.69763,
    r: 2.15765,
    fill: "#ccc"
  })), _circle328 || (_circle328 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 275.69763,
    r: 2.15765,
    fill: "#ccc"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,313.77541a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,740.06047,313.77541Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,313.77541a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,748.6757,313.77541Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle329 || (_circle329 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.93496,
    cy: 275.69763,
    r: 2.15765,
    fill: "#ccc"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,313.77541a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,765.89152,313.77541Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle330 || (_circle330 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 275.69763,
    r: 2.15765,
    fill: "#ccc"
  })), _circle331 || (_circle331 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.75088,
    cy: 275.69763,
    r: 2.15765,
    fill: "#ccc"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,313.77541a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,791.707,313.77541Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle332 || (_circle332 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.9667,
    cy: 275.69763,
    r: 2.15765,
    fill: "#ccc"
  })), _circle333 || (_circle333 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.58193,
    cy: 275.69763,
    r: 2.15765,
    fill: "#ccc"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,313.77541a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,817.52336,313.77541Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle334 || (_circle334 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.78262,
    cy: 275.69763,
    r: 2.15765,
    fill: "#ccc"
  })), _circle335 || (_circle335 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.39785,
    cy: 275.69763,
    r: 2.15765,
    fill: "#ccc"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,313.77541a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,843.33928,313.77541Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle336 || (_circle336 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.61367,
    cy: 275.69763,
    r: 2.15765,
    fill: "#ccc"
  })), _circle337 || (_circle337 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.21377,
    cy: 275.69763,
    r: 2.15765,
    fill: "#ccc"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M869.16985,313.77541a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,869.16985,313.77541Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M877.77043,313.77541a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,877.77043,313.77541Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle338 || (_circle338 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.02969,
    cy: 275.69763,
    r: 2.15765,
    fill: "#ccc"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M326.94524,322.39076a2.1576,2.1576,0,1,0,2.15722,2.15759A2.15753,2.15753,0,0,0,326.94524,322.39076Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle339 || (_circle339 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.21963,
    cy: 284.31299,
    r: 2.15765,
    fill: "#ccc"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M344.16057,322.39076a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,344.16057,322.39076Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle340 || (_circle340 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.42031,
    cy: 284.31299,
    r: 2.15765,
    fill: "#ccc"
  })), _circle341 || (_circle341 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.03555,
    cy: 284.31299,
    r: 2.15765,
    fill: "#ccc"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M369.97649,322.39076a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,369.97649,322.39076Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle342 || (_circle342 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.25137,
    cy: 284.31299,
    r: 2.15765,
    fill: "#ccc"
  })), _circle343 || (_circle343 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.85146,
    cy: 284.31299,
    r: 2.15765,
    fill: "#ccc"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,322.39076a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,395.79289,322.39076Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,322.39076a2.1576,2.1576,0,1,0,2.15722,2.15759A2.15753,2.15753,0,0,0,404.40813,322.39076Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle344 || (_circle344 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 284.31299,
    r: 2.15765,
    fill: "#ccc"
  })), _circle345 || (_circle345 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.225,
    cy: 284.31299,
    r: 2.15765,
    fill: "#ccc"
  })), _circle346 || (_circle346 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.05605,
    cy: 284.31299,
    r: 2.15765,
    fill: "#ccc"
  })), _circle347 || (_circle347 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.65615,
    cy: 284.31299,
    r: 2.15765,
    fill: "#ccc"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,322.39076a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15753,2.15753,0,0,0,662.59758,322.39076Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,322.39076a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15742,2.15742,0,0,0,714.24406,322.39076Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle348 || (_circle348 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 284.31299,
    r: 2.15765,
    fill: "#ccc"
  })), _circle349 || (_circle349 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 284.31299,
    r: 2.15765,
    fill: "#ccc"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,322.39076a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,740.06047,322.39076Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,322.39076a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,748.6757,322.39076Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle350 || (_circle350 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.93496,
    cy: 284.31299,
    r: 2.15765,
    fill: "#ccc"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,322.39076a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,765.89152,322.39076Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle351 || (_circle351 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 284.31299,
    r: 2.15765,
    fill: "#ccc"
  })), _circle352 || (_circle352 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.75088,
    cy: 284.31299,
    r: 2.15765,
    fill: "#ccc"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,322.39076a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15742,2.15742,0,0,0,791.707,322.39076Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle353 || (_circle353 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.9667,
    cy: 284.31299,
    r: 2.15765,
    fill: "#ccc"
  })), _circle354 || (_circle354 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.58193,
    cy: 284.31299,
    r: 2.15765,
    fill: "#ccc"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,322.39076a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,817.52336,322.39076Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle355 || (_circle355 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.78262,
    cy: 284.31299,
    r: 2.15765,
    fill: "#ccc"
  })), _circle356 || (_circle356 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.39785,
    cy: 284.31299,
    r: 2.15765,
    fill: "#ccc"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,322.39076a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15753,2.15753,0,0,0,843.33928,322.39076Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle357 || (_circle357 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.61367,
    cy: 284.31299,
    r: 2.15765,
    fill: "#ccc"
  })), _circle358 || (_circle358 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.21377,
    cy: 284.31299,
    r: 2.15765,
    fill: "#ccc"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M869.16985,322.39076a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,869.16985,322.39076Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M877.77043,322.39076a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,877.77043,322.39076Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle359 || (_circle359 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.02969,
    cy: 284.31299,
    r: 2.15765,
    fill: "#ccc"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M326.94524,330.991a2.1576,2.1576,0,1,0,2.15722,2.1576A2.15753,2.15753,0,0,0,326.94524,330.991Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle360 || (_circle360 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.21963,
    cy: 292.91327,
    r: 2.15765,
    fill: "#ccc"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M344.16057,330.991a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15742,2.15742,0,0,0,344.16057,330.991Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle361 || (_circle361 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.42031,
    cy: 292.91327,
    r: 2.15765,
    fill: "#ccc"
  })), _circle362 || (_circle362 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.03555,
    cy: 292.91327,
    r: 2.15765,
    fill: "#ccc"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M369.97649,330.991a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15742,2.15742,0,0,0,369.97649,330.991Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle363 || (_circle363 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.25137,
    cy: 292.91327,
    r: 2.15765,
    fill: "#ccc"
  })), _circle364 || (_circle364 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.85146,
    cy: 292.91327,
    r: 2.15765,
    fill: "#ccc"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,330.991a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,395.79289,330.991Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,330.991a2.1576,2.1576,0,1,0,2.15722,2.1576A2.15753,2.15753,0,0,0,404.40813,330.991Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle365 || (_circle365 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.225,
    cy: 292.91327,
    r: 2.15765,
    fill: "#ccc"
  })), _circle366 || (_circle366 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.84023,
    cy: 292.91327,
    r: 2.15765,
    fill: "#ccc"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M636.78166,330.991a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,636.78166,330.991Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle367 || (_circle367 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.05605,
    cy: 292.91327,
    r: 2.15765,
    fill: "#ccc"
  })), _circle368 || (_circle368 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.65615,
    cy: 292.91327,
    r: 2.15765,
    fill: "#ccc"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,330.991a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,662.59758,330.991Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,330.991a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,740.06047,330.991Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,330.991a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,748.6757,330.991Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle369 || (_circle369 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.93496,
    cy: 292.91327,
    r: 2.15765,
    fill: "#ccc"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,330.991a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,765.89152,330.991Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle370 || (_circle370 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 292.91327,
    r: 2.15765,
    fill: "#ccc"
  })), _circle371 || (_circle371 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.75088,
    cy: 292.91327,
    r: 2.15765,
    fill: "#ccc"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,330.991a2.1576,2.1576,0,1,0,2.15772,2.1576A2.15742,2.15742,0,0,0,791.707,330.991Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle372 || (_circle372 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.9667,
    cy: 292.91327,
    r: 2.15765,
    fill: "#ccc"
  })), _circle373 || (_circle373 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.58193,
    cy: 292.91327,
    r: 2.15765,
    fill: "#ccc"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,330.991a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,817.52336,330.991Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle374 || (_circle374 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.78262,
    cy: 292.91327,
    r: 2.15765,
    fill: "#ccc"
  })), _circle375 || (_circle375 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.39785,
    cy: 292.91327,
    r: 2.15765,
    fill: "#ccc"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,330.991a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,843.33928,330.991Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle376 || (_circle376 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.61367,
    cy: 292.91327,
    r: 2.15765,
    fill: "#ccc"
  })), _circle377 || (_circle377 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.21377,
    cy: 292.91327,
    r: 2.15765,
    fill: "#ccc"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M869.16985,330.991a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15742,2.15742,0,0,0,869.16985,330.991Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M877.77043,330.991a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,877.77043,330.991Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle378 || (_circle378 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.02969,
    cy: 292.91327,
    r: 2.15765,
    fill: "#ccc"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M326.94524,339.6064a2.15759,2.15759,0,1,0,2.15722,2.15759A2.15752,2.15752,0,0,0,326.94524,339.6064Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle379 || (_circle379 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.21963,
    cy: 301.52863,
    r: 2.15765,
    fill: "#ccc"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M344.16057,339.6064a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,344.16057,339.6064Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle380 || (_circle380 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.42031,
    cy: 301.52863,
    r: 2.15765,
    fill: "#ccc"
  })), _circle381 || (_circle381 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.03555,
    cy: 301.52863,
    r: 2.15765,
    fill: "#ccc"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M369.97649,339.6064a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,369.97649,339.6064Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle382 || (_circle382 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.25137,
    cy: 301.52863,
    r: 2.15765,
    fill: "#ccc"
  })), _circle383 || (_circle383 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.85146,
    cy: 301.52863,
    r: 2.15765,
    fill: "#ccc"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,339.6064a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,395.79289,339.6064Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,339.6064a2.15759,2.15759,0,1,0,2.15722,2.15759A2.15752,2.15752,0,0,0,404.40813,339.6064Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M610.96574,339.6064A2.15759,2.15759,0,1,0,613.123,341.764,2.15752,2.15752,0,0,0,610.96574,339.6064Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle384 || (_circle384 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.225,
    cy: 301.52863,
    r: 2.15765,
    fill: "#ccc"
  })), _circle385 || (_circle385 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.84023,
    cy: 301.52863,
    r: 2.15765,
    fill: "#ccc"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M636.78166,339.6064a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,636.78166,339.6064Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle386 || (_circle386 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.05605,
    cy: 301.52863,
    r: 2.15765,
    fill: "#ccc"
  })), _circle387 || (_circle387 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.65615,
    cy: 301.52863,
    r: 2.15765,
    fill: "#ccc"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,339.6064a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,662.59758,339.6064Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle388 || (_circle388 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 301.52863,
    r: 2.15765,
    fill: "#ccc"
  })), _circle389 || (_circle389 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 301.52863,
    r: 2.15765,
    fill: "#ccc"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,339.6064a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,740.06047,339.6064Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,339.6064a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,748.6757,339.6064Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle390 || (_circle390 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.93496,
    cy: 301.52863,
    r: 2.15765,
    fill: "#ccc"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,339.6064a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,765.89152,339.6064Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle391 || (_circle391 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 301.52863,
    r: 2.15765,
    fill: "#ccc"
  })), _circle392 || (_circle392 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.75088,
    cy: 301.52863,
    r: 2.15765,
    fill: "#ccc"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,339.6064a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,791.707,339.6064Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle393 || (_circle393 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.9667,
    cy: 301.52863,
    r: 2.15765,
    fill: "#ccc"
  })), _circle394 || (_circle394 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.58193,
    cy: 301.52863,
    r: 2.15765,
    fill: "#ccc"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,339.6064a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,817.52336,339.6064Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle395 || (_circle395 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.78262,
    cy: 301.52863,
    r: 2.15765,
    fill: "#ccc"
  })), _circle396 || (_circle396 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.39785,
    cy: 301.52863,
    r: 2.15765,
    fill: "#ccc"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,339.6064a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,843.33928,339.6064Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle397 || (_circle397 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.61367,
    cy: 301.52863,
    r: 2.15765,
    fill: "#ccc"
  })), _circle398 || (_circle398 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.21377,
    cy: 301.52863,
    r: 2.15765,
    fill: "#ccc"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M869.16985,339.6064a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,869.16985,339.6064Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M877.77043,339.6064a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,877.77043,339.6064Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle399 || (_circle399 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.02969,
    cy: 301.52863,
    r: 2.15765,
    fill: "#ccc"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M326.94524,348.20668a2.15763,2.15763,0,1,0,2.15722,2.15759A2.15752,2.15752,0,0,0,326.94524,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M335.56047,348.20668a2.15763,2.15763,0,1,0,2.15771,2.15759A2.15783,2.15783,0,0,0,335.56047,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M344.16057,348.20668a2.15763,2.15763,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,344.16057,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M352.76115,348.20668a2.15763,2.15763,0,1,0,2.15772,2.15759A2.15752,2.15752,0,0,0,352.76115,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M361.37639,348.20668a2.15763,2.15763,0,1,0,2.15771,2.15759A2.15783,2.15783,0,0,0,361.37639,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M369.97649,348.20668a2.15763,2.15763,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,369.97649,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M378.59221,348.20668a2.15763,2.15763,0,1,0,2.15771,2.15759A2.15752,2.15752,0,0,0,378.59221,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M387.19231,348.20668a2.15763,2.15763,0,1,0,2.15771,2.15759A2.15783,2.15783,0,0,0,387.19231,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,348.20668a2.15763,2.15763,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,395.79289,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M610.96574,348.20668a2.15763,2.15763,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,610.96574,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M619.56584,348.20668a2.15763,2.15763,0,1,0,2.15772,2.15759A2.15752,2.15752,0,0,0,619.56584,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M628.18108,348.20668a2.15763,2.15763,0,1,0,2.15771,2.15759A2.15783,2.15783,0,0,0,628.18108,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M636.78166,348.20668a2.15763,2.15763,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,636.78166,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M645.3969,348.20668a2.15763,2.15763,0,1,0,2.15771,2.15759A2.15752,2.15752,0,0,0,645.3969,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M653.997,348.20668a2.15763,2.15763,0,1,0,2.15772,2.15759A2.15783,2.15783,0,0,0,653.997,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,348.20668a2.15763,2.15763,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,662.59758,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M671.21281,348.20668a2.15763,2.15763,0,1,0,2.15772,2.15759A2.15752,2.15752,0,0,0,671.21281,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,348.20668a2.15763,2.15763,0,1,0,2.15772,2.15759A2.15742,2.15742,0,0,0,679.81291,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,348.20668a2.15763,2.15763,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,688.42863,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M697.02873,348.20668a2.15763,2.15763,0,1,0,2.15772,2.15759A2.15752,2.15752,0,0,0,697.02873,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M705.644,348.20668a2.15763,2.15763,0,1,0,2.15771,2.15759A2.15783,2.15783,0,0,0,705.644,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,348.20668a2.15763,2.15763,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,714.24406,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M722.84465,348.20668a2.15763,2.15763,0,1,0,2.15771,2.15759A2.15753,2.15753,0,0,0,722.84465,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M731.45988,348.20668a2.15763,2.15763,0,1,0,2.15772,2.15759A2.15783,2.15783,0,0,0,731.45988,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,348.20668a2.15763,2.15763,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,740.06047,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,348.20668a2.15763,2.15763,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,748.6757,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M757.2758,348.20668a2.15763,2.15763,0,1,0,2.15772,2.15759A2.15783,2.15783,0,0,0,757.2758,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,348.20668a2.15763,2.15763,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,765.89152,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M783.09172,348.20668a2.15763,2.15763,0,1,0,2.15771,2.15759A2.15783,2.15783,0,0,0,783.09172,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,348.20668a2.15763,2.15763,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,791.707,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M800.30754,348.20668a2.15763,2.15763,0,1,0,2.15772,2.15759A2.15752,2.15752,0,0,0,800.30754,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M808.92277,348.20668a2.15763,2.15763,0,1,0,2.15772,2.15759A2.15783,2.15783,0,0,0,808.92277,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,348.20668a2.15763,2.15763,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,817.52336,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M826.12346,348.20668a2.15763,2.15763,0,1,0,2.15771,2.15759A2.15752,2.15752,0,0,0,826.12346,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M834.73869,348.20668a2.15763,2.15763,0,1,0,2.15772,2.15759A2.15783,2.15783,0,0,0,834.73869,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,348.20668a2.15763,2.15763,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,843.33928,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M851.95451,348.20668a2.15763,2.15763,0,1,0,2.15772,2.15759A2.15752,2.15752,0,0,0,851.95451,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M860.55461,348.20668a2.15763,2.15763,0,1,0,2.15772,2.15759A2.15783,2.15783,0,0,0,860.55461,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M869.16985,348.20668a2.15763,2.15763,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,869.16985,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M877.77043,348.20668a2.15763,2.15763,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,877.77043,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M886.37053,348.20668a2.15763,2.15763,0,1,0,2.15771,2.15759A2.15783,2.15783,0,0,0,886.37053,348.20668Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M326.94524,356.807a2.1576,2.1576,0,1,0,2.15722,2.15759A2.15752,2.15752,0,0,0,326.94524,356.807Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle400 || (_circle400 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.21963,
    cy: 318.72919,
    r: 2.15765,
    fill: "#ccc"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M344.16057,356.807a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,344.16057,356.807Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle401 || (_circle401 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.42031,
    cy: 318.72919,
    r: 2.15765,
    fill: "#ccc"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,356.807a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,395.79289,356.807Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,356.807a2.1576,2.1576,0,1,0,2.15722,2.15759A2.15752,2.15752,0,0,0,404.40813,356.807Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M602.36516,356.807a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,602.36516,356.807Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M610.96574,356.807a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,610.96574,356.807Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle402 || (_circle402 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.225,
    cy: 318.72919,
    r: 2.15765,
    fill: "#ccc"
  })), _circle403 || (_circle403 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.84023,
    cy: 318.72919,
    r: 2.15765,
    fill: "#ccc"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M636.78166,356.807a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,636.78166,356.807Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle404 || (_circle404 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.05605,
    cy: 318.72919,
    r: 2.15765,
    fill: "#ccc"
  })), _circle405 || (_circle405 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.65615,
    cy: 318.72919,
    r: 2.15765,
    fill: "#ccc"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,356.807a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,662.59758,356.807Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle406 || (_circle406 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 318.72919,
    r: 2.15765,
    fill: "#ccc"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,356.807a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15742,2.15742,0,0,0,679.81291,356.807Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,356.807a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,688.42863,356.807Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle407 || (_circle407 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 318.72919,
    r: 2.15765,
    fill: "#ccc"
  })), _circle408 || (_circle408 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 318.72919,
    r: 2.15765,
    fill: "#ccc"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,356.807a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,714.24406,356.807Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle409 || (_circle409 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 318.72919,
    r: 2.15765,
    fill: "#ccc"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,356.807a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,748.6757,356.807Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle410 || (_circle410 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.93496,
    cy: 318.72919,
    r: 2.15765,
    fill: "#ccc"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,356.807a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,765.89152,356.807Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle411 || (_circle411 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 318.72919,
    r: 2.15765,
    fill: "#ccc"
  })), _circle412 || (_circle412 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.9667,
    cy: 318.72919,
    r: 2.15765,
    fill: "#ccc"
  })), _circle413 || (_circle413 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.58193,
    cy: 318.72919,
    r: 2.15765,
    fill: "#ccc"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,356.807a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,817.52336,356.807Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle414 || (_circle414 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.78262,
    cy: 318.72919,
    r: 2.15765,
    fill: "#ccc"
  })), _circle415 || (_circle415 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.39785,
    cy: 318.72919,
    r: 2.15765,
    fill: "#ccc"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,356.807a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,843.33928,356.807Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle416 || (_circle416 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.61367,
    cy: 318.72919,
    r: 2.15765,
    fill: "#ccc"
  })), _circle417 || (_circle417 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.21377,
    cy: 318.72919,
    r: 2.15765,
    fill: "#ccc"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M869.16985,356.807a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,869.16985,356.807Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M877.77043,356.807a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,877.77043,356.807Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle418 || (_circle418 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.02969,
    cy: 318.72919,
    r: 2.15765,
    fill: "#ccc"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M326.94524,365.42232a2.15759,2.15759,0,1,0,2.15722,2.15759A2.15748,2.15748,0,0,0,326.94524,365.42232Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle419 || (_circle419 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.21963,
    cy: 327.34454,
    r: 2.15765,
    fill: "#ccc"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M344.16057,365.42232a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,344.16057,365.42232Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle420 || (_circle420 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.42031,
    cy: 327.34454,
    r: 2.15765,
    fill: "#ccc"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,365.42232a2.15759,2.15759,0,1,0,2.15722,2.15759A2.15748,2.15748,0,0,0,404.40813,365.42232Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle421 || (_circle421 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 327.34454,
    r: 2.15765,
    fill: "#ccc"
  })), _circle422 || (_circle422 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.40908,
    cy: 327.34454,
    r: 2.15765,
    fill: "#ccc"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M602.36516,365.42232a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,602.36516,365.42232Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M610.96574,365.42232a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,610.96574,365.42232Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle423 || (_circle423 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.225,
    cy: 327.34454,
    r: 2.15765,
    fill: "#ccc"
  })), _circle424 || (_circle424 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.84023,
    cy: 327.34454,
    r: 2.15765,
    fill: "#ccc"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M636.78166,365.42232a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,636.78166,365.42232Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle425 || (_circle425 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.05605,
    cy: 327.34454,
    r: 2.15765,
    fill: "#ccc"
  })), _circle426 || (_circle426 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.65615,
    cy: 327.34454,
    r: 2.15765,
    fill: "#ccc"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,365.42232a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,662.59758,365.42232Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle427 || (_circle427 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 327.34454,
    r: 2.15765,
    fill: "#ccc"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,365.42232a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,679.81291,365.42232Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,365.42232a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,688.42863,365.42232Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle428 || (_circle428 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 327.34454,
    r: 2.15765,
    fill: "#ccc"
  })), _circle429 || (_circle429 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 327.34454,
    r: 2.15765,
    fill: "#ccc"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,365.42232a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,714.24406,365.42232Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle430 || (_circle430 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 327.34454,
    r: 2.15765,
    fill: "#ccc"
  })), _circle431 || (_circle431 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 327.34454,
    r: 2.15765,
    fill: "#ccc"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,365.42232a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,748.6757,365.42232Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle432 || (_circle432 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.93496,
    cy: 327.34454,
    r: 2.15765,
    fill: "#ccc"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,365.42232a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,765.89152,365.42232Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle433 || (_circle433 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 327.34454,
    r: 2.15765,
    fill: "#ccc"
  })), _circle434 || (_circle434 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.58193,
    cy: 327.34454,
    r: 2.15765,
    fill: "#ccc"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M817.52336,365.42232a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,817.52336,365.42232Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle435 || (_circle435 = /*#__PURE__*/React.createElement("circle", {
    cx: 597.78262,
    cy: 327.34454,
    r: 2.15765,
    fill: "#ccc"
  })), _circle436 || (_circle436 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.39785,
    cy: 327.34454,
    r: 2.15765,
    fill: "#ccc"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,365.42232a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,843.33928,365.42232Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle437 || (_circle437 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.61367,
    cy: 327.34454,
    r: 2.15765,
    fill: "#ccc"
  })), _circle438 || (_circle438 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.21377,
    cy: 327.34454,
    r: 2.15765,
    fill: "#ccc"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M869.16985,365.42232a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,869.16985,365.42232Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M877.77043,365.42232a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,877.77043,365.42232Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle439 || (_circle439 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.21963,
    cy: 335.94482,
    r: 2.15765,
    fill: "#ccc"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M344.16057,374.0226a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,344.16057,374.0226Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle440 || (_circle440 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.42031,
    cy: 335.94482,
    r: 2.15765,
    fill: "#ccc"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,374.0226a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,395.79289,374.0226Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,374.0226a2.15759,2.15759,0,1,0,2.15722,2.15759A2.15752,2.15752,0,0,0,404.40813,374.0226Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,374.0226a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,421.62346,374.0226Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle441 || (_circle441 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.8832,
    cy: 335.94482,
    r: 2.15765,
    fill: "#ccc"
  })), _circle442 || (_circle442 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.40908,
    cy: 335.94482,
    r: 2.15765,
    fill: "#ccc"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M602.36516,374.0226a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,602.36516,374.0226Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M610.96574,374.0226a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,610.96574,374.0226Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle443 || (_circle443 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.225,
    cy: 335.94482,
    r: 2.15765,
    fill: "#ccc"
  })), _circle444 || (_circle444 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.84023,
    cy: 335.94482,
    r: 2.15765,
    fill: "#ccc"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M636.78166,374.0226a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,636.78166,374.0226Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle445 || (_circle445 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.05605,
    cy: 335.94482,
    r: 2.15765,
    fill: "#ccc"
  })), _circle446 || (_circle446 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.65615,
    cy: 335.94482,
    r: 2.15765,
    fill: "#ccc"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,374.0226a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,662.59758,374.0226Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle447 || (_circle447 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 335.94482,
    r: 2.15765,
    fill: "#ccc"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,374.0226a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15742,2.15742,0,0,0,679.81291,374.0226Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,374.0226a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,688.42863,374.0226Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle448 || (_circle448 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 335.94482,
    r: 2.15765,
    fill: "#ccc"
  })), _circle449 || (_circle449 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 335.94482,
    r: 2.15765,
    fill: "#ccc"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,374.0226a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,714.24406,374.0226Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle450 || (_circle450 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 335.94482,
    r: 2.15765,
    fill: "#ccc"
  })), _circle451 || (_circle451 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 335.94482,
    r: 2.15765,
    fill: "#ccc"
  })), _circle452 || (_circle452 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.93496,
    cy: 335.94482,
    r: 2.15765,
    fill: "#ccc"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,374.0226a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,765.89152,374.0226Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle453 || (_circle453 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 335.94482,
    r: 2.15765,
    fill: "#ccc"
  })), _circle454 || (_circle454 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.75088,
    cy: 335.94482,
    r: 2.15765,
    fill: "#ccc"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,374.0226a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,791.707,374.0226Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle455 || (_circle455 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.9667,
    cy: 335.94482,
    r: 2.15765,
    fill: "#ccc"
  })), _circle456 || (_circle456 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.39785,
    cy: 335.94482,
    r: 2.15765,
    fill: "#ccc"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,374.0226a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,843.33928,374.0226Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle457 || (_circle457 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.61367,
    cy: 335.94482,
    r: 2.15765,
    fill: "#ccc"
  })), _circle458 || (_circle458 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.21377,
    cy: 335.94482,
    r: 2.15765,
    fill: "#ccc"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M869.16985,374.0226a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,869.16985,374.0226Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M877.77043,374.0226a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,877.77043,374.0226Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle459 || (_circle459 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.21963,
    cy: 344.56018,
    r: 2.15765,
    fill: "#ccc"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M344.16057,382.638a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15742,2.15742,0,0,0,344.16057,382.638Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle460 || (_circle460 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.42031,
    cy: 344.56018,
    r: 2.15765,
    fill: "#ccc"
  })), _circle461 || (_circle461 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.25137,
    cy: 344.56018,
    r: 2.15765,
    fill: "#ccc"
  })), _circle462 || (_circle462 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 344.56018,
    r: 2.15765,
    fill: "#ccc"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,382.638a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15742,2.15742,0,0,0,421.62346,382.638Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle463 || (_circle463 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.40908,
    cy: 344.56018,
    r: 2.15765,
    fill: "#ccc"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M602.36516,382.638a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15742,2.15742,0,0,0,602.36516,382.638Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M610.96574,382.638a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,610.96574,382.638Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle464 || (_circle464 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.225,
    cy: 344.56018,
    r: 2.15765,
    fill: "#ccc"
  })), _circle465 || (_circle465 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.84023,
    cy: 344.56018,
    r: 2.15765,
    fill: "#ccc"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M636.78166,382.638a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,636.78166,382.638Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle466 || (_circle466 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.05605,
    cy: 344.56018,
    r: 2.15765,
    fill: "#ccc"
  })), _circle467 || (_circle467 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.65615,
    cy: 344.56018,
    r: 2.15765,
    fill: "#ccc"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,382.638a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,662.59758,382.638Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle468 || (_circle468 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 344.56018,
    r: 2.15765,
    fill: "#ccc"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,382.638a2.1576,2.1576,0,1,0,2.15772,2.1576A2.15743,2.15743,0,0,0,679.81291,382.638Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,382.638a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,688.42863,382.638Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle469 || (_circle469 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 344.56018,
    r: 2.15765,
    fill: "#ccc"
  })), _circle470 || (_circle470 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 344.56018,
    r: 2.15765,
    fill: "#ccc"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,382.638a2.1576,2.1576,0,1,0,2.15772,2.1576A2.15742,2.15742,0,0,0,714.24406,382.638Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle471 || (_circle471 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 344.56018,
    r: 2.15765,
    fill: "#ccc"
  })), _circle472 || (_circle472 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 344.56018,
    r: 2.15765,
    fill: "#ccc"
  })), _circle473 || (_circle473 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.93496,
    cy: 344.56018,
    r: 2.15765,
    fill: "#ccc"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,382.638a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,765.89152,382.638Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle474 || (_circle474 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 344.56018,
    r: 2.15765,
    fill: "#ccc"
  })), _circle475 || (_circle475 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.75088,
    cy: 344.56018,
    r: 2.15765,
    fill: "#ccc"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,382.638a2.1576,2.1576,0,1,0,2.15772,2.1576A2.15742,2.15742,0,0,0,791.707,382.638Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle476 || (_circle476 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.9667,
    cy: 344.56018,
    r: 2.15765,
    fill: "#ccc"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,382.638a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,843.33928,382.638Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle477 || (_circle477 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.61367,
    cy: 344.56018,
    r: 2.15765,
    fill: "#ccc"
  })), _circle478 || (_circle478 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.21377,
    cy: 344.56018,
    r: 2.15765,
    fill: "#ccc"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M869.16985,382.638a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15742,2.15742,0,0,0,869.16985,382.638Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M877.77043,382.638a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,877.77043,382.638Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M344.16057,391.23824a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,344.16057,391.23824Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle479 || (_circle479 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.42031,
    cy: 353.16046,
    r: 2.15765,
    fill: "#ccc"
  })), _circle480 || (_circle480 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.03555,
    cy: 353.16046,
    r: 2.15765,
    fill: "#ccc"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M369.97649,391.23824a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,369.97649,391.23824Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle481 || (_circle481 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.25137,
    cy: 353.16046,
    r: 2.15765,
    fill: "#ccc"
  })), _circle482 || (_circle482 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 353.16046,
    r: 2.15765,
    fill: "#ccc"
  })), _circle483 || (_circle483 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.8832,
    cy: 353.16046,
    r: 2.15765,
    fill: "#ccc"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,391.23824a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,447.43938,391.23824Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle484 || (_circle484 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.40908,
    cy: 353.16046,
    r: 2.15765,
    fill: "#ccc"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M602.36516,391.23824a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,602.36516,391.23824Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M610.96574,391.23824a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,610.96574,391.23824Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle485 || (_circle485 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.225,
    cy: 353.16046,
    r: 2.15765,
    fill: "#ccc"
  })), _circle486 || (_circle486 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.84023,
    cy: 353.16046,
    r: 2.15765,
    fill: "#ccc"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M636.78166,391.23824a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,636.78166,391.23824Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle487 || (_circle487 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.05605,
    cy: 353.16046,
    r: 2.15765,
    fill: "#ccc"
  })), _circle488 || (_circle488 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.65615,
    cy: 353.16046,
    r: 2.15765,
    fill: "#ccc"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,391.23824a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,662.59758,391.23824Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle489 || (_circle489 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 353.16046,
    r: 2.15765,
    fill: "#ccc"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,391.23824a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15742,2.15742,0,0,0,679.81291,391.23824Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,391.23824a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,688.42863,391.23824Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle490 || (_circle490 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 353.16046,
    r: 2.15765,
    fill: "#ccc"
  })), _circle491 || (_circle491 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 353.16046,
    r: 2.15765,
    fill: "#ccc"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,391.23824a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,714.24406,391.23824Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle492 || (_circle492 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 353.16046,
    r: 2.15765,
    fill: "#ccc"
  })), _circle493 || (_circle493 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 353.16046,
    r: 2.15765,
    fill: "#ccc"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,391.23824a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,740.06047,391.23824Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle494 || (_circle494 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.93496,
    cy: 353.16046,
    r: 2.15765,
    fill: "#ccc"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,391.23824a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,765.89152,391.23824Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle495 || (_circle495 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 353.16046,
    r: 2.15765,
    fill: "#ccc"
  })), _circle496 || (_circle496 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.75088,
    cy: 353.16046,
    r: 2.15765,
    fill: "#ccc"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M791.707,391.23824a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,791.707,391.23824Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M843.33928,391.23824a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,843.33928,391.23824Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle497 || (_circle497 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.61367,
    cy: 353.16046,
    r: 2.15765,
    fill: "#ccc"
  })), _circle498 || (_circle498 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.21377,
    cy: 353.16046,
    r: 2.15765,
    fill: "#ccc"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M869.16985,391.23824a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,869.16985,391.23824Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M369.97649,399.83852a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,369.97649,399.83852Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle499 || (_circle499 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.25137,
    cy: 361.76074,
    r: 2.15765,
    fill: "#ccc"
  })), _circle500 || (_circle500 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.85146,
    cy: 361.76074,
    r: 2.15765,
    fill: "#ccc"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,399.83852a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,395.79289,399.83852Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M456.04,399.83852a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,456.04,399.83852Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M585.14983,399.83852a2.15759,2.15759,0,1,0,2.15722,2.15759A2.15748,2.15748,0,0,0,585.14983,399.83852Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle501 || (_circle501 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.40908,
    cy: 361.76074,
    r: 2.15765,
    fill: "#ccc"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M602.36516,399.83852a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,602.36516,399.83852Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M610.96574,399.83852a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,610.96574,399.83852Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle502 || (_circle502 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.225,
    cy: 361.76074,
    r: 2.15765,
    fill: "#ccc"
  })), _circle503 || (_circle503 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.84023,
    cy: 361.76074,
    r: 2.15765,
    fill: "#ccc"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M636.78166,399.83852a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,636.78166,399.83852Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle504 || (_circle504 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.05605,
    cy: 361.76074,
    r: 2.15765,
    fill: "#ccc"
  })), _circle505 || (_circle505 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.65615,
    cy: 361.76074,
    r: 2.15765,
    fill: "#ccc"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,399.83852a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,662.59758,399.83852Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle506 || (_circle506 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 361.76074,
    r: 2.15765,
    fill: "#ccc"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,399.83852a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,679.81291,399.83852Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,399.83852a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,688.42863,399.83852Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle507 || (_circle507 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 361.76074,
    r: 2.15765,
    fill: "#ccc"
  })), _circle508 || (_circle508 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 361.76074,
    r: 2.15765,
    fill: "#ccc"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,399.83852a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,714.24406,399.83852Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle509 || (_circle509 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 361.76074,
    r: 2.15765,
    fill: "#ccc"
  })), _circle510 || (_circle510 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 361.76074,
    r: 2.15765,
    fill: "#ccc"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,399.83852a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,740.06047,399.83852Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,399.83852a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,765.89152,399.83852Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle511 || (_circle511 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 361.76074,
    r: 2.15765,
    fill: "#ccc"
  })), _circle512 || (_circle512 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.61367,
    cy: 361.76074,
    r: 2.15765,
    fill: "#ccc"
  })), _circle513 || (_circle513 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.21377,
    cy: 361.76074,
    r: 2.15765,
    fill: "#ccc"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M387.19231,408.45387a2.15763,2.15763,0,1,0,2.15771,2.15766A2.15786,2.15786,0,0,0,387.19231,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,408.45387a2.15763,2.15763,0,1,0,2.15723,2.15766A2.15754,2.15754,0,0,0,395.79289,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M438.83928,408.45387a2.15763,2.15763,0,1,0,2.15771,2.15766A2.15786,2.15786,0,0,0,438.83928,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M456.04,408.45387a2.15763,2.15763,0,1,0,2.15723,2.15766A2.15754,2.15754,0,0,0,456.04,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M593.74992,408.45387a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15785,2.15785,0,0,0,593.74992,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M602.36516,408.45387a2.15763,2.15763,0,1,0,2.15771,2.15766A2.15744,2.15744,0,0,0,602.36516,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M610.96574,408.45387a2.15763,2.15763,0,1,0,2.15723,2.15766A2.15754,2.15754,0,0,0,610.96574,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M619.56584,408.45387a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15754,2.15754,0,0,0,619.56584,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M628.18108,408.45387a2.15763,2.15763,0,1,0,2.15771,2.15766A2.15786,2.15786,0,0,0,628.18108,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M636.78166,408.45387a2.15763,2.15763,0,1,0,2.15723,2.15766A2.15754,2.15754,0,0,0,636.78166,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M645.3969,408.45387a2.15763,2.15763,0,1,0,2.15771,2.15766A2.15754,2.15754,0,0,0,645.3969,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M653.997,408.45387a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15785,2.15785,0,0,0,653.997,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,408.45387a2.15763,2.15763,0,1,0,2.15723,2.15766A2.15754,2.15754,0,0,0,662.59758,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M671.21281,408.45387a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15754,2.15754,0,0,0,671.21281,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,408.45387a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15744,2.15744,0,0,0,679.81291,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,408.45387a2.15763,2.15763,0,1,0,2.15723,2.15766A2.15754,2.15754,0,0,0,688.42863,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M697.02873,408.45387a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15754,2.15754,0,0,0,697.02873,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M705.644,408.45387a2.15763,2.15763,0,1,0,2.15771,2.15766A2.15786,2.15786,0,0,0,705.644,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,408.45387a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15744,2.15744,0,0,0,714.24406,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M722.84465,408.45387a2.15763,2.15763,0,1,0,2.15771,2.15766A2.15755,2.15755,0,0,0,722.84465,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M731.45988,408.45387a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15785,2.15785,0,0,0,731.45988,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,408.45387a2.15763,2.15763,0,1,0,2.15723,2.15766A2.15754,2.15754,0,0,0,740.06047,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,408.45387a2.15763,2.15763,0,1,0,2.15723,2.15766A2.15754,2.15754,0,0,0,748.6757,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M851.95451,408.45387a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15754,2.15754,0,0,0,851.95451,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M860.55461,408.45387a2.15763,2.15763,0,1,0,2.15772,2.15766A2.15785,2.15785,0,0,0,860.55461,408.45387Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle514 || (_circle514 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.85146,
    cy: 378.97638,
    r: 2.15765,
    fill: "#ccc"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M395.79289,417.05415a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,395.79289,417.05415Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,417.05415a2.1576,2.1576,0,1,0,2.15722,2.1576A2.15753,2.15753,0,0,0,404.40813,417.05415Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle515 || (_circle515 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 378.97638,
    r: 2.15765,
    fill: "#ccc"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,417.05415a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15742,2.15742,0,0,0,421.62346,417.05415Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle516 || (_circle516 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.8832,
    cy: 378.97638,
    r: 2.15765,
    fill: "#ccc"
  })), _circle517 || (_circle517 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.49844,
    cy: 378.97638,
    r: 2.15765,
    fill: "#ccc"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,417.05415a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15742,2.15742,0,0,0,447.43938,417.05415Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M456.04,417.05415a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,456.04,417.05415Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle518 || (_circle518 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.40908,
    cy: 378.97638,
    r: 2.15765,
    fill: "#ccc"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M602.36516,417.05415a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15742,2.15742,0,0,0,602.36516,417.05415Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M610.96574,417.05415a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,610.96574,417.05415Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle519 || (_circle519 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.225,
    cy: 378.97638,
    r: 2.15765,
    fill: "#ccc"
  })), _circle520 || (_circle520 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.84023,
    cy: 378.97638,
    r: 2.15765,
    fill: "#ccc"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M636.78166,417.05415a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,636.78166,417.05415Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle521 || (_circle521 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.05605,
    cy: 378.97638,
    r: 2.15765,
    fill: "#ccc"
  })), _circle522 || (_circle522 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.65615,
    cy: 378.97638,
    r: 2.15765,
    fill: "#ccc"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,417.05415a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,662.59758,417.05415Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle523 || (_circle523 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 378.97638,
    r: 2.15765,
    fill: "#ccc"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,417.05415a2.1576,2.1576,0,1,0,2.15772,2.1576A2.15743,2.15743,0,0,0,679.81291,417.05415Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,417.05415a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,688.42863,417.05415Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle524 || (_circle524 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 378.97638,
    r: 2.15765,
    fill: "#ccc"
  })), _circle525 || (_circle525 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 378.97638,
    r: 2.15765,
    fill: "#ccc"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,417.05415a2.1576,2.1576,0,1,0,2.15772,2.1576A2.15742,2.15742,0,0,0,714.24406,417.05415Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle526 || (_circle526 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 378.97638,
    r: 2.15765,
    fill: "#ccc"
  })), _circle527 || (_circle527 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 378.97638,
    r: 2.15765,
    fill: "#ccc"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,417.05415a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,740.06047,417.05415Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,417.05415a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,748.6757,417.05415Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle528 || (_circle528 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.93496,
    cy: 378.97638,
    r: 2.15765,
    fill: "#ccc"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,417.05415a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,765.89152,417.05415Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle529 || (_circle529 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 378.97638,
    r: 2.15765,
    fill: "#ccc"
  })), _circle530 || (_circle530 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.61367,
    cy: 378.97638,
    r: 2.15765,
    fill: "#ccc"
  })), _circle531 || (_circle531 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.21377,
    cy: 378.97638,
    r: 2.15765,
    fill: "#ccc"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,425.66957a2.1576,2.1576,0,1,0,2.15722,2.15759A2.15748,2.15748,0,0,0,404.40813,425.66957Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle532 || (_circle532 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 387.5918,
    r: 2.15765,
    fill: "#ccc"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,425.66957a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,421.62346,425.66957Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle533 || (_circle533 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.8832,
    cy: 387.5918,
    r: 2.15765,
    fill: "#ccc"
  })), _circle534 || (_circle534 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.49844,
    cy: 387.5918,
    r: 2.15765,
    fill: "#ccc"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,425.66957a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,447.43938,425.66957Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M456.04,425.66957a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,456.04,425.66957Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle535 || (_circle535 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.31435,
    cy: 387.5918,
    r: 2.15765,
    fill: "#ccc"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M602.36516,425.66957a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,602.36516,425.66957Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M610.96574,425.66957a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,610.96574,425.66957Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle536 || (_circle536 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.225,
    cy: 387.5918,
    r: 2.15765,
    fill: "#ccc"
  })), _circle537 || (_circle537 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.84023,
    cy: 387.5918,
    r: 2.15765,
    fill: "#ccc"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M636.78166,425.66957a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,636.78166,425.66957Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle538 || (_circle538 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.05605,
    cy: 387.5918,
    r: 2.15765,
    fill: "#ccc"
  })), _circle539 || (_circle539 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.65615,
    cy: 387.5918,
    r: 2.15765,
    fill: "#ccc"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,425.66957a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,662.59758,425.66957Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle540 || (_circle540 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 387.5918,
    r: 2.15765,
    fill: "#ccc"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,425.66957a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,679.81291,425.66957Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,425.66957a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,688.42863,425.66957Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle541 || (_circle541 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 387.5918,
    r: 2.15765,
    fill: "#ccc"
  })), _circle542 || (_circle542 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 387.5918,
    r: 2.15765,
    fill: "#ccc"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,425.66957a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,714.24406,425.66957Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle543 || (_circle543 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 387.5918,
    r: 2.15765,
    fill: "#ccc"
  })), _circle544 || (_circle544 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 387.5918,
    r: 2.15765,
    fill: "#ccc"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,425.66957a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,740.06047,425.66957Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,425.66957a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,748.6757,425.66957Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle545 || (_circle545 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.93496,
    cy: 387.5918,
    r: 2.15765,
    fill: "#ccc"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,425.66957a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,765.89152,425.66957Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle546 || (_circle546 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.15078,
    cy: 387.5918,
    r: 2.15765,
    fill: "#ccc"
  })), _circle547 || (_circle547 = /*#__PURE__*/React.createElement("circle", {
    cx: 632.21377,
    cy: 387.5918,
    r: 2.15765,
    fill: "#ccc"
  })), _circle548 || (_circle548 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 396.19202,
    r: 2.15765,
    fill: "#ccc"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,434.26979a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,421.62346,434.26979Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle549 || (_circle549 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.8832,
    cy: 396.19202,
    r: 2.15765,
    fill: "#ccc"
  })), _circle550 || (_circle550 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.49844,
    cy: 396.19202,
    r: 2.15765,
    fill: "#ccc"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,434.26979a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,447.43938,434.26979Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M456.04,434.26979a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,456.04,434.26979Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle551 || (_circle551 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.31435,
    cy: 396.19202,
    r: 2.15765,
    fill: "#ccc"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M473.25529,434.26979a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,473.25529,434.26979Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M610.96574,434.26979a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,610.96574,434.26979Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle552 || (_circle552 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.225,
    cy: 396.19202,
    r: 2.15765,
    fill: "#ccc"
  })), _circle553 || (_circle553 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.84023,
    cy: 396.19202,
    r: 2.15765,
    fill: "#ccc"
  })), _circle554 || (_circle554 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.65615,
    cy: 396.19202,
    r: 2.15765,
    fill: "#ccc"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,434.26979a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,662.59758,434.26979Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle555 || (_circle555 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 396.19202,
    r: 2.15765,
    fill: "#ccc"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,434.26979a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15742,2.15742,0,0,0,679.81291,434.26979Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,434.26979a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,688.42863,434.26979Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle556 || (_circle556 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 396.19202,
    r: 2.15765,
    fill: "#ccc"
  })), _circle557 || (_circle557 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 396.19202,
    r: 2.15765,
    fill: "#ccc"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,434.26979a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,714.24406,434.26979Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle558 || (_circle558 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 396.19202,
    r: 2.15765,
    fill: "#ccc"
  })), _circle559 || (_circle559 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 396.19202,
    r: 2.15765,
    fill: "#ccc"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,434.26979a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,740.06047,434.26979Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,434.26979a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,748.6757,434.26979Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle560 || (_circle560 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.93496,
    cy: 396.19202,
    r: 2.15765,
    fill: "#ccc"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,434.26979a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,765.89152,434.26979Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle561 || (_circle561 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 404.80743,
    r: 2.15765,
    fill: "#ccc"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,442.88521a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,421.62346,442.88521Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle562 || (_circle562 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.8832,
    cy: 404.80743,
    r: 2.15765,
    fill: "#ccc"
  })), _circle563 || (_circle563 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.49844,
    cy: 404.80743,
    r: 2.15765,
    fill: "#ccc"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,442.88521a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,447.43938,442.88521Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M456.04,442.88521a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,456.04,442.88521Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle564 || (_circle564 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.31435,
    cy: 404.80743,
    r: 2.15765,
    fill: "#ccc"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M473.25529,442.88521a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,473.25529,442.88521Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M481.871,442.88521a2.15759,2.15759,0,1,0,2.15722,2.15759A2.15752,2.15752,0,0,0,481.871,442.88521Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,442.88521a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,662.59758,442.88521Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle565 || (_circle565 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 404.80743,
    r: 2.15765,
    fill: "#ccc"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,442.88521a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15742,2.15742,0,0,0,679.81291,442.88521Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,442.88521a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,688.42863,442.88521Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle566 || (_circle566 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 404.80743,
    r: 2.15765,
    fill: "#ccc"
  })), _circle567 || (_circle567 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 404.80743,
    r: 2.15765,
    fill: "#ccc"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,442.88521a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,714.24406,442.88521Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle568 || (_circle568 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 404.80743,
    r: 2.15765,
    fill: "#ccc"
  })), _circle569 || (_circle569 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 404.80743,
    r: 2.15765,
    fill: "#ccc"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,442.88521a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,740.06047,442.88521Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,442.88521a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,748.6757,442.88521Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle570 || (_circle570 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.93496,
    cy: 404.80743,
    r: 2.15765,
    fill: "#ccc"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M765.89152,442.88521a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,765.89152,442.88521Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,451.48543a2.15762,2.15762,0,1,0,2.15722,2.15759A2.15752,2.15752,0,0,0,404.40813,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M413.00822,451.48543a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15783,2.15783,0,0,0,413.00822,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,451.48543a2.15762,2.15762,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,421.62346,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M430.224,451.48543a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15752,2.15752,0,0,0,430.224,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M438.83928,451.48543A2.15762,2.15762,0,1,0,440.997,453.643,2.15783,2.15783,0,0,0,438.83928,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,451.48543a2.15762,2.15762,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,447.43938,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M456.04,451.48543a2.15762,2.15762,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,456.04,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M464.6552,451.48543a2.15762,2.15762,0,1,0,2.15771,2.15759A2.15783,2.15783,0,0,0,464.6552,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M473.25529,451.48543A2.15762,2.15762,0,1,0,475.413,453.643,2.15741,2.15741,0,0,0,473.25529,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M481.871,451.48543a2.15762,2.15762,0,1,0,2.15722,2.15759A2.15752,2.15752,0,0,0,481.871,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M490.47111,451.48543a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15783,2.15783,0,0,0,490.47111,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,451.48543a2.15762,2.15762,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,662.59758,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M671.21281,451.48543a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15752,2.15752,0,0,0,671.21281,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,451.48543a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15742,2.15742,0,0,0,679.81291,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,451.48543a2.15762,2.15762,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,688.42863,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M697.02873,451.48543a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15752,2.15752,0,0,0,697.02873,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M705.644,451.48543a2.15762,2.15762,0,1,0,2.15771,2.15759A2.15783,2.15783,0,0,0,705.644,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,451.48543a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15741,2.15741,0,0,0,714.24406,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M722.84465,451.48543a2.15762,2.15762,0,1,0,2.15771,2.15759A2.15753,2.15753,0,0,0,722.84465,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M731.45988,451.48543a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15783,2.15783,0,0,0,731.45988,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,451.48543a2.15762,2.15762,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,740.06047,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,451.48543a2.15762,2.15762,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,748.6757,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M757.2758,451.48543a2.15762,2.15762,0,1,0,2.15772,2.15759A2.15783,2.15783,0,0,0,757.2758,451.48543Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,460.08577a2.1576,2.1576,0,1,0,2.15722,2.15759A2.15748,2.15748,0,0,0,404.40813,460.08577Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle571 || (_circle571 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 422.008,
    r: 2.15765,
    fill: "#ccc"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,460.08577a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,421.62346,460.08577Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle572 || (_circle572 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.8832,
    cy: 422.008,
    r: 2.15765,
    fill: "#ccc"
  })), _circle573 || (_circle573 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.49844,
    cy: 422.008,
    r: 2.15765,
    fill: "#ccc"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,460.08577a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,447.43938,460.08577Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M456.04,460.08577a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,456.04,460.08577Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle574 || (_circle574 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.31435,
    cy: 422.008,
    r: 2.15765,
    fill: "#ccc"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M473.25529,460.08577a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,473.25529,460.08577Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M481.871,460.08577a2.1576,2.1576,0,1,0,2.15722,2.15759A2.15748,2.15748,0,0,0,481.871,460.08577Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle575 || (_circle575 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.13027,
    cy: 422.008,
    r: 2.15765,
    fill: "#ccc"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M499.07121,460.08577a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,499.07121,460.08577Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle576 || (_circle576 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.34609,
    cy: 422.008,
    r: 2.15765,
    fill: "#ccc"
  })), _circle577 || (_circle577 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.94619,
    cy: 422.008,
    r: 2.15765,
    fill: "#ccc"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M524.90227,460.08577a2.1576,2.1576,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,524.90227,460.08577Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M662.59758,460.08577a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,662.59758,460.08577Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle578 || (_circle578 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 422.008,
    r: 2.15765,
    fill: "#ccc"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,460.08577a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,679.81291,460.08577Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,460.08577a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,688.42863,460.08577Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle579 || (_circle579 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 422.008,
    r: 2.15765,
    fill: "#ccc"
  })), _circle580 || (_circle580 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 422.008,
    r: 2.15765,
    fill: "#ccc"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,460.08577a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,714.24406,460.08577Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle581 || (_circle581 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 422.008,
    r: 2.15765,
    fill: "#ccc"
  })), _circle582 || (_circle582 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.11904,
    cy: 422.008,
    r: 2.15765,
    fill: "#ccc"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M740.06047,460.08577a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,740.06047,460.08577Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M748.6757,460.08577a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,748.6757,460.08577Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,468.70113a2.15759,2.15759,0,1,0,2.15722,2.15759A2.15748,2.15748,0,0,0,404.40813,468.70113Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle583 || (_circle583 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 430.62335,
    r: 2.15765,
    fill: "#ccc"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,468.70113a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,421.62346,468.70113Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle584 || (_circle584 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.8832,
    cy: 430.62335,
    r: 2.15765,
    fill: "#ccc"
  })), _circle585 || (_circle585 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.49844,
    cy: 430.62335,
    r: 2.15765,
    fill: "#ccc"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M447.43938,468.70113a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,447.43938,468.70113Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle586 || (_circle586 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.94619,
    cy: 430.62335,
    r: 2.15765,
    fill: "#ccc"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M524.90227,468.70113a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15738,2.15738,0,0,0,524.90227,468.70113Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M533.50285,468.70113a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,533.50285,468.70113Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle587 || (_circle587 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 430.62335,
    r: 2.15765,
    fill: "#ccc"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,468.70113a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,679.81291,468.70113Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,468.70113a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,688.42863,468.70113Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle588 || (_circle588 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 430.62335,
    r: 2.15765,
    fill: "#ccc"
  })), _circle589 || (_circle589 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 430.62335,
    r: 2.15765,
    fill: "#ccc"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M714.24406,468.70113a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,714.24406,468.70113Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle590 || (_circle590 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.50381,
    cy: 430.62335,
    r: 2.15765,
    fill: "#ccc"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M404.40813,477.30141a2.15759,2.15759,0,1,0,2.15722,2.15759A2.15752,2.15752,0,0,0,404.40813,477.30141Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle591 || (_circle591 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 439.22363,
    r: 2.15765,
    fill: "#ccc"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,477.30141a2.15759,2.15759,0,1,0,2.15771,2.15759A2.15742,2.15742,0,0,0,421.62346,477.30141Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle592 || (_circle592 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.8832,
    cy: 439.22363,
    r: 2.15765,
    fill: "#ccc"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M524.90227,477.30141A2.15759,2.15759,0,1,0,527.06,479.459,2.15742,2.15742,0,0,0,524.90227,477.30141Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M533.50285,477.30141a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,533.50285,477.30141Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,477.30141a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15742,2.15742,0,0,0,679.81291,477.30141Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,477.30141a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,688.42863,477.30141Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle593 || (_circle593 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 439.22363,
    r: 2.15765,
    fill: "#ccc"
  })), _circle594 || (_circle594 = /*#__PURE__*/React.createElement("circle", {
    cx: 477.30312,
    cy: 439.22363,
    r: 2.15765,
    fill: "#ccc"
  })), _circle595 || (_circle595 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.66738,
    cy: 447.83899,
    r: 2.15765,
    fill: "#ccc"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M421.62346,485.91676a2.1576,2.1576,0,1,0,2.15771,2.1576A2.15742,2.15742,0,0,0,421.62346,485.91676Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,485.91676a2.1576,2.1576,0,1,0,2.15772,2.1576A2.15743,2.15743,0,0,0,679.81291,485.91676Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,485.91676a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,688.42863,485.91676Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle596 || (_circle596 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 447.83899,
    r: 2.15765,
    fill: "#ccc"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M413.00822,494.517a2.15763,2.15763,0,1,0,2.15772,2.1576A2.15784,2.15784,0,0,0,413.00822,494.517Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,494.517a2.15763,2.15763,0,1,0,2.15772,2.1576A2.15743,2.15743,0,0,0,679.81291,494.517Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,494.517a2.15763,2.15763,0,1,0,2.15723,2.1576A2.15753,2.15753,0,0,0,688.42863,494.517Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M697.02873,494.517a2.15763,2.15763,0,1,0,2.15772,2.1576A2.15753,2.15753,0,0,0,697.02873,494.517Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle597 || (_circle597 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 465.03955,
    r: 2.15765,
    fill: "#ccc"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,503.11732a2.1576,2.1576,0,1,0,2.15772,2.1576A2.15739,2.15739,0,0,0,679.81291,503.11732Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,503.11732a2.1576,2.1576,0,1,0,2.15723,2.1576A2.15749,2.15749,0,0,0,688.42863,503.11732Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle598 || (_circle598 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 465.03955,
    r: 2.15765,
    fill: "#ccc"
  })), _circle599 || (_circle599 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.87197,
    cy: 473.65491,
    r: 2.15765,
    fill: "#ccc"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,511.73268a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15738,2.15738,0,0,0,679.81291,511.73268Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,511.73268a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,688.42863,511.73268Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _circle600 || (_circle600 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.68789,
    cy: 473.65491,
    r: 2.15765,
    fill: "#ccc"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,520.333a2.1576,2.1576,0,1,0,2.15772,2.15759A2.15743,2.15743,0,0,0,679.81291,520.333Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,520.333a2.1576,2.1576,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,688.42863,520.333Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,528.94832a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15742,2.15742,0,0,0,679.81291,528.94832Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,528.94832a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,688.42863,528.94832Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,537.5486a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15742,2.15742,0,0,0,679.81291,537.5486Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M679.81291,546.164a2.15759,2.15759,0,1,0,2.15772,2.15759A2.15742,2.15742,0,0,0,679.81291,546.164Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,554.76424a2.15762,2.15762,0,1,0,2.15723,2.15759A2.15752,2.15752,0,0,0,688.42863,554.76424Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,563.36452a2.15759,2.15759,0,1,0,2.15723,2.15759A2.15748,2.15748,0,0,0,688.42863,563.36452Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M688.42863,571.97987a2.15763,2.15763,0,1,0,2.15723,2.15766A2.15754,2.15754,0,0,0,688.42863,571.97987Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#ccc"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M596.59318,291.5583a29.02435,29.02435,0,0,0-4.185-.28637,27.01678,27.01678,0,0,0-4.252.30841,27.64905,27.64905,0,0,0-23.54785,26.91858c0,.52862.02246,1.07934.06543,1.63006a29.61644,29.61644,0,0,0,.439,3.32605,2.153,2.153,0,0,0,.92724,4.09839c.02588,0,.0503-.00677.07617-.00769.07227.23773.13282.4729.21.71167a66.00975,66.00975,0,0,0,5.26464,11.9834c1.36621,2.55536,2.88623,5.08856,4.42871,7.48968a178.20433,178.20433,0,0,0,14.416,19.09668,2.16047,2.16047,0,1,0,3.36963.661,175.99491,175.99491,0,0,0,14.94775-19.75769c1.564-2.40112,3.0625-4.91223,4.44971-7.46759a67.62681,67.62681,0,0,0,5.24268-12.00549,33.27345,33.27345,0,0,0,1.65234-8.28265c.04394-.5066.06641-.99115.06641-1.47583A27.61715,27.61715,0,0,0,596.59318,291.5583Zm5.59522,28.50464a9.67513,9.67513,0,0,1-5.68311,7.33545,9.34676,9.34676,0,0,1-3.92089.837h-.17627a9.49857,9.49857,0,0,1-4.252-1.07935,9.68356,9.68356,0,0,1-5.15429-7.11511,7.28777,7.28777,0,0,1-.13233-1.71826,9.68157,9.68157,0,0,1,5.44141-8.54688,9.79042,9.79042,0,0,1,4.47168-.99133,9.5673,9.5673,0,0,1,3.72265.81506,9.74186,9.74186,0,0,1,5.81543,8.89942A9.15,9.15,0,0,1,602.1884,320.06294Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#3f3d56"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M784.10149,164.37038c.042-.48236.0625-.94373.0625-1.40522a26.443,26.443,0,0,0-52.874,0c0,.46149.022.92286.064,1.40522a32.69722,32.69722,0,0,0,1.67724,8.24249,70.05447,70.05447,0,0,0,5.707,12.5318,2.15214,2.15214,0,0,0,2.17481,3.67456,166.08122,166.08122,0,0,0,16.28662,21.68506,2.14244,2.14244,0,1,0,.92578.16717c.51221-.56817,1.50733-1.68792,2.8418-3.26373,0-.021,0-.021.02148-.021q.81738-1.00671,1.8252-2.20214c.2959-.36579.6084-.75721.92187-1.1507l-.002.02008a2.19168,2.19168,0,1,0,1.624-2.08319c2.54688-3.28729,5.44483-7.25195,8.17285-11.53052,1.50977-2.36987,2.978-4.82385,4.29932-7.2987a64.25938,64.25938,0,0,0,4.78272-11.13685A31.50243,31.50243,0,0,0,784.10149,164.37038Zm-17.05127.10492a9.24833,9.24833,0,0,1-9.12354,7.76007h-.18945a9.22317,9.22317,0,0,1-8.95459-7.76007,7.38748,7.38748,0,0,1-.126-1.67792,9.26013,9.26013,0,0,1,18.51856.16778A8.79583,8.79583,0,0,1,767.05022,164.4753Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#3f3d56"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M629.61418,690.83534a6.50506,6.50506,0,0,0-2.95019-4.05l-9.50977-5.8-44.6001-27.22-44.23-26.99006a6.53465,6.53465,0,0,0-3.78027-.95h-.02a6.48585,6.48585,0,0,0-1.15967.17,6.30643,6.30643,0,0,0-1.64014.65,4.99485,4.99485,0,0,0-.98.67,6.28739,6.28739,0,0,0-1.43017,1.64l-7.08985,11.62-.10986.18a6.51159,6.51159,0,0,0-.78027,4.94995,6.65806,6.65806,0,0,0,.78027,1.88,6.405,6.405,0,0,0,2.17969,2.18006l.03027.01995,43.37988,26.47.62989.38,54.30029,33.14a6.57217,6.57217,0,0,0,9.00977-2.18l7.20019-11.8A6.52991,6.52991,0,0,0,629.61418,690.83534Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#e2e2e2"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M572.704,650.74538a6.45061,6.45061,0,0,0-2.74023-4.24l-33.29-19.02a16.34636,16.34636,0,0,0-12.12988-1.66h-.02a16.81186,16.81186,0,0,0-2.65967.94c-.38037.16-.75.35-1.12012.55a16.36383,16.36383,0,0,0-8.52,13.26,16.49378,16.49378,0,0,0,2.1001,9.21,16.29472,16.29472,0,0,0,3.83985,4.56l29.79,24.47a6.5396,6.5396,0,0,0,9.12989-1.64l.62011-.92.27-.4,13.66016-20.21a6.3146,6.3146,0,0,0,.67969-1.22q.13549-.33.24023-.66A6.55,6.55,0,0,0,572.704,650.74538Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#2f2e41"
  })), _circle601 || (_circle601 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.35446,
    cy: 513.46519,
    r: 50.12206,
    fill: "#e2e2e2"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M490.29387,729.60536H476.46379a6.56807,6.56807,0,0,0-6.5498,6.56v115.21a6.5595,6.5595,0,0,0,6.5498,6.55h13.83008a6.5596,6.5596,0,0,0,6.55029-6.55v-115.21A6.56817,6.56817,0,0,0,490.29387,729.60536Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#e2e2e2"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M520.25383,729.60536H506.434a6.56807,6.56807,0,0,0-6.54981,6.56v115.21a6.5595,6.5595,0,0,0,6.54981,6.55h13.81982a6.56168,6.56168,0,0,0,6.56006-6.55v-115.21A6.57023,6.57023,0,0,0,520.25383,729.60536Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#e2e2e2"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M570.453,724.70691c0,40.86108-38.43624,54.04142-79.29731,54.04142S422.482,765.568,422.482,724.70691s27.50529-110.51,68.36636-110.51S570.453,683.84584,570.453,724.70691Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#2f2e41"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M489.64223,572.27746l-.05213-1.87305c3.48453-.09694,6.55659-.31553,8.865-2.002a5.75769,5.75769,0,0,0,2.23019-4.24088,3.29128,3.29128,0,0,0-1.07965-2.71081c-1.53237-1.29412-3.99807-.87524-5.79521-.05121l-1.54975.71062,2.97191-21.71843,1.85568.25426-2.52789,18.47443a6.61182,6.61182,0,0,1,6.25433.89994,5.12369,5.12369,0,0,1,1.74226,4.207,7.6164,7.6164,0,0,1-2.99706,5.68774C496.59392,572.08266,492.73944,572.19058,489.64223,572.27746Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 277.92472,
    y: 502.00377,
    width: 10.08777,
    height: 1.87305,
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 246.08285,
    y: 502.00377,
    width: 10.08777,
    height: 1.87305,
    fill: "#2f2e41"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M450.69368,539.92915c3.89813-5.86788,10.75721-8.35524,17.521-8.96031,7.61315-.68106,14.96945.787,22.40249,2.21331,8.18044,1.56974,16.83815,3.03841,25.08093,1.05378a24.725,24.725,0,0,0,16.80711-13.5776,31.6274,31.6274,0,0,0,1.84145-21.08877c-1.93156-7.47935-6.726-14.06049-12.5382-19.0312-11.86273-10.14531-27.916-14.70479-43.35644-14.27531a73.30107,73.30107,0,0,0-42.49445,14.9418,69.0194,69.0194,0,0,0-24.48539,38.371,71.952,71.952,0,0,0,3.48422,45.25668c3.37881,7.83812,8.26549,14.90444,12.03622,22.54518,3.5108,7.11405,6.21461,15.38523,4.03016,23.32022-1.91682,6.96281-7.54445,13.14865-14.6094,15.039a15.34168,15.34168,0,0,1-17.06032-6.96473c-3.53174-5.569-3.61624-12.86329,1.68647-17.35977a13.01622,13.01622,0,0,1,18.77733,1.87369,13.39825,13.39825,0,0,1,2.68,9.82336c-.26123,1.76869,2.44556,2.532,2.70921.74689a15.84886,15.84886,0,0,0-29.55026-10.23364c-3.19781,6.01244-1.47241,13.2644,2.58692,18.40376a17.93772,17.93772,0,0,0,18.289,6.5766c7.3891-1.7065,13.43377-7.57932,16.27641-14.48054,3.16468-7.68307,1.71471-16.25681-1.37037-23.71223-3.33487-8.05909-8.28714-15.28693-12.20347-23.05312a65.65575,65.65575,0,0,1-6.66212-22.43247,70.98032,70.98032,0,0,1,10.12325-44.96015,65.9702,65.9702,0,0,1,36.33575-27.6153,68.94394,68.94394,0,0,1,45.62064,1.20628c14.27615,5.625,28.06144,17.88347,27.8959,34.3474-.07071,7.03282-2.68144,14.205-8.0684,18.89582-6.43783,5.60593-15.40169,6.08516-23.49451,5.21026-8.14416-.88045-16.05286-3.25891-24.23217-3.86564-7.11426-.52774-14.78947.02091-21.14164,3.55546a21.13817,21.13817,0,0,0-7.34328,6.8122c-1.00333,1.51033,1.429,2.91884,2.426,1.418Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#2f2e41"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M458.86418,650.5154a6.50618,6.50618,0,0,0-4.29-2.6l-8.89013-1.35-4.77979-.73a6.55172,6.55172,0,0,0-7.17041,4.33,6.23305,6.23305,0,0,0-.28955,1.17l-5.78027,37.98-.4502,2.94-4.71,30.97-6.3999,42a6.57288,6.57288,0,0,0,5.5,7.47l13.66015,2.08a6.59064,6.59064,0,0,0,7.46973-5.5l.18994-1.28,10.79-70.87,6.3501-41.74A6.47074,6.47074,0,0,0,458.86418,650.5154Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#e2e2e2"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M452.74406,636.46535a15.30688,15.30688,0,0,0-2.46-.64,16.37055,16.37055,0,0,0-18.51025,11.41l-.6499,2.15-10.43994,34.77a6.56583,6.56583,0,0,0,5.02978,7.8l1.2002.24.2998.06,23.98047,4.82a6.5696,6.5696,0,0,0,1.38965.15,6.08439,6.08439,0,0,0,1.12988-.1,6.55491,6.55491,0,0,0,5.28027-5.12l4.7002-38.05005A16.359,16.359,0,0,0,452.74406,636.46535Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#2f2e41"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M768.18959,859.549H753.42982a6.50753,6.50753,0,0,1-6.5-6.5V730.0353a6.50753,6.50753,0,0,1,6.5-6.5h14.75977a6.50753,6.50753,0,0,1,6.5,6.5V853.049A6.50753,6.50753,0,0,1,768.18959,859.549Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#e2e2e2"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M738.99721,859.549H724.23744a6.50753,6.50753,0,0,1-6.5-6.5V730.0353a6.50753,6.50753,0,0,1,6.5-6.5h14.75977a6.50753,6.50753,0,0,1,6.5,6.5V853.049A6.50753,6.50753,0,0,1,738.99721,859.549Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#e2e2e2"
  })), _circle602 || (_circle602 = /*#__PURE__*/React.createElement("circle", {
    cx: 517.43179,
    cy: 503.92114,
    r: 51,
    fill: "#e2e2e2"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M701.7351,556.56544c-3.30591-.0918-7.42029-.20654-10.59-2.522a8.13274,8.13274,0,0,1-3.20007-6.07275,5.47084,5.47084,0,0,1,1.86035-4.49316c1.65552-1.39893,4.073-1.72706,6.67822-.96143l-2.69921-19.72559,1.98144-.27148,3.17322,23.18994-1.65466-.75928c-1.91834-.87988-4.55164-1.32764-6.188.05517a3.51516,3.51516,0,0,0-1.15271,2.89551,6.14681,6.14681,0,0,0,2.38122,4.52783c2.46668,1.80176,5.74622,2.03418,9.46582,2.13819Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 478.87277,
    y: 484.25634,
    width: 10.77161,
    height: 2,
    fill: "#2f2e41"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M737.61974,538.19306a13.984,13.984,0,0,0,8.54693-11.46718,15.25854,15.25854,0,0,0-6.10845-13.41178c-8.69984-6.56548-20.69477-2.41061-29.80393-7.8227a11.22231,11.22231,0,0,1-5.11038-12.59434c1.25217-5.38172,5.32615-9.31084,9.96211-12.008,9.16646-5.33294,20.325-7.3218,30.825-6.9337,21.59124.79806,41.48225,12.00883,54.37994,29.1618a88.79589,88.79589,0,0,1,14.0287,27.98831c3.08505,10.35516,4.79414,21.693,2.83807,32.42466a35.48159,35.48159,0,0,1-16.3251,24.64432c-8.28159,5.39266-17.99382,8.15829-27.58,10.16241-2.3905.49976-4.79149.94708-7.19685,1.36891-1.89819.33288-1.09366,3.22448.79752,2.89283,19.31142-3.3866,42.05115-9.37332,50.50124-29.22963,4.54756-10.686,4.223-22.78541,2.07221-33.9965a93.35948,93.35948,0,0,0-11.372-30.04568c-11.22221-18.86194-29.49-32.97963-51.24613-37.12475a67.57658,67.57658,0,0,0-32.66395,1.57836c-10.00515,3.12229-21.36842,9.34177-22.32885,21.00987a13.91,13.91,0,0,0,6.60677,13.11088c4.3392,2.69715,9.57005,3.356,14.55495,3.79205,5.37338.47,11.53258.79171,15.84115,4.46214,4.013,3.41863,5.69595,9.34236,3.21117,14.14518a10.66246,10.66246,0,0,1-5.22768,4.99968,1.55247,1.55247,0,0,0-1.04765,1.84518,1.50819,1.50819,0,0,0,1.84517,1.04766Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#2f2e41"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M789.33846,623.215l-.2085-.37537a6.00028,6.00028,0,0,0-5.11377-3.08484l-26.31689-.57672v-3.48053a5.99983,5.99983,0,0,0-6-6h-16a6.00014,6.00014,0,0,0-6,6v2.86694l-23.85694-.52276a6.00005,6.00005,0,0,0-5.269,2.89923v.00006a140.27313,140.27313,0,0,0-2.5127,140.57648l.2085.37536a5.9995,5.9995,0,0,0,5.11328,3.08484l78.17383,1.71314a5.99954,5.99954,0,0,0,5.269-2.89929v-.00007A140.272,140.272,0,0,0,789.33846,623.215Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#2f2e41"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M628.84416,695.79536l-7.20019,11.8a6.42638,6.42638,0,0,1-1.81006,1.93,6.00526,6.00526,0,0,1-7.79-2.81l-6.56983-13.22a5.994,5.994,0,0,1,2.69-8.04l8.99023-4.47,9.50977,5.8a6.56687,6.56687,0,0,1,2.18017,9.01Z",
    transform: "translate(-228.34084 -40.23537)",
    opacity: 0.2
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M667.81283,602.51783h14.75958a6,6,0,0,1,6,6V724.15228a13.37978,13.37978,0,0,1-13.37978,13.37978h0a13.37977,13.37977,0,0,1-13.37977-13.37977V608.51783A6,6,0,0,1,667.81283,602.51783Z",
    transform: "translate(147.87765 1532.80285) rotate(-116.46097)",
    fill: "#e2e2e2"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M655.371,657.22731c-3.38051-.55472-6.42081,2.70707-6.93073,6.09464s.78037,6.75881,2.04661,9.94193c2.24957,5.65507,4.5516,11.402,8.34846,16.15845s9.3787,8.46337,15.46435,8.53595c5.79179.06909,11.0788-3.05795,16.01767-6.084l46.32834-28.38554c4.901-3.00289,10.13752-6.40521,12.07354-11.81719a17.21847,17.21847,0,0,0-.26646-11.05044,26.66644,26.66644,0,0,0-26.11229-17.79739c-13.13618.76374-23.38549,10.99679-34.12338,18.602a97.03216,97.03216,0,0,1-35.43309,15.59993",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#2f2e41"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M970.46847,859.76463h-738.294a1.19068,1.19068,0,1,1,0-2.38136h738.294a1.19068,1.19068,0,1,1,0,2.38136Z",
    transform: "translate(-228.34084 -40.23537)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInPage);
export default __webpack_public_path__ + "static/media/signInPage.fde079137622e090145f1f437c557a5c.svg";
export { ForwardRef as ReactComponent };